var esn = {};
(function () {
    var headerSettings = null,
        shopSettings = JSON.parse($("#shop-settings").text());

    // Formatting a string ... the never ending story
    if (!String.prototype.format) {
        String.prototype.format = function() {
            var args = arguments;
            return this.replace(/{(\d+)}/g, function(match, number) {
                return typeof args[number] != 'undefined' ? args[number] : match;
            });
        };
    }

    esn.getShopSettings = function() {
        return shopSettings;
    };
    esn.getMoneyFormat = function () {
        return shopSettings.money_format;
    };
    esn.getLocales = function () {
        return shopSettings.locales;
    };
    esn.getOpinewTexts = function () {
        return shopSettings.opinew;
    };
    esn.getHiddenProductsSettings = function () {
        return shopSettings.hidden_products;
    };
    esn.getHeaderSettings = function () {
        if (!headerSettings) {
            headerSettings = JSON.parse(document.getElementById("header-settings").innerHTML);
        }
        return headerSettings;
    };
    esn.getISettings = function() {
        return (typeof shopSettings.isettings !== "undefined" ? shopSettings.isettings : false);
    };
    esn.getCookie = function(name) {
        var cookie;
        return (cookie = Cookies.get(name)) !== undefined ? cookie.replace('+', ' ') : false;
    };
    /**
     * get user's cookie consent choice from Cookiebot.consent object
     * @param {String} cookieType Cookie consent type, can be "marketing", "necessary", "preferences" or "statistics"
     * @returns {Boolean} Whether or not user has accepted the given cookie type
     */
    esn.getCookiebotConsent = function(cookieType) {
        return Cookiebot.consent[cookieType];
    };

    // Manager object for handling external content in accordance to user preference, utilizing a 2-click solution
    esn.ExternalContent = {
        consentTypes: ['GMaps'], // array of strings representing the different types of external content providers
        switchSelector: '#ConsentSwitch', // 2-click toggle switch selector
        sessionNamespace: 'ExternalContentConsent',
        switchWrapperSelector: '.consent-switch-wrapper',

        /**
         * set the given session variable to true or false
         * @param varName {String} Has to be a value of this.consentTypes
         * @param permission Any value that can be interpreted as either true or false
         */
        setConsent: function(varName, permission) {
            if (this.consentTypes.indexOf(varName) >= 0) {
                sessionStorage.setItem(this.sessionNamespace + '.' + varName, !!permission);
            }
        },

        getConsent: function(varName) {
            if (this.consentTypes.indexOf(varName) >= 0) {
                return sessionStorage.getItem(this.sessionNamespace + '.' + varName) === 'true';
            }

            return null;
        },

        showSwitch: function() {
            if (this.getConsent('GMaps')) {
                $(this.switchSelector).click();
            }
            $(this.switchWrapperSelector).removeClass('hidden');
        },

        hideSwitch: function() {
            $(this.switchWrapperSelector).addClass('hidden');
        },

        toggleSwitch: function() {
            var $ele = $(this.switchWrapperSelector);
            if ($ele.hasClass('hidden')) {
                $ele.removeClass('hidden');
            } else {
                $ele.addClass('hidden');
            }
        },

        // remove Google Maps related sources and objects
        removeGMapSources: function() {
            if (window.google !== undefined && google.maps !== undefined) {
                delete google.maps;
                $('script').each(function () {
                    if (this.src.indexOf('googleapis.com/maps') >= 0) {
                        //console.log('removed', this.src);
                        $(this).remove();
                    }
                });
            }
        },

        /**
         * Sets up event handler for consent switch toggle on/off. Offers option to run custom code for both the check
         * and uncheck event.
         * @param callbackChecked {Function} Callback function to call if switch was toggled on
         * @param callbackUnchecked {Function} Callback function to call if switch was toggled off
         */
        setSwitchHandler: function(callbackChecked = null, callbackUnchecked = null) {
            var self = this;

            $(this.switchSelector).on('change', function() {
                var $toggleSwitchWrapper = $(self.switchWrapperSelector),
                    $privacyDisclaimer = $toggleSwitchWrapper.find('label small'),
                    $switchLabel = $('#ConsentSwitchLabel');

                if (this.checked) {
                    // save 2-click consent preference to session
                    esn.ExternalContent.setConsent('GMaps', true);

                    // change consent switch styles
                    setTimeout(function() {
                        $toggleSwitchWrapper.addClass('active');
                    }, 500);
                    $privacyDisclaimer.slideUp(400);

                    // update label
                    $switchLabel.find('div span').text($switchLabel.attr('data-text-off'));

                    if (callbackChecked) {
                        callbackChecked();
                    }
                }
                else {
                    esn.ExternalContent.setConsent('GMaps', false);

                    // change consent switch styles
                    setTimeout(function() {
                        $toggleSwitchWrapper.removeClass('active');
                        setTimeout(function() {
                            $privacyDisclaimer.slideDown(400);
                        }, 500);
                    }, 150);

                    // update label
                    $switchLabel.find('div span').text($switchLabel.attr('data-text-on'));

                    // remove any additional sources loaded by Google Maps
                    esn.ExternalContent.removeGMapSources();

                    if (callbackUnchecked) {
                        callbackUnchecked();
                    }
                }
            });
        }
    };

    // automatically open cart drawer if anchor link is set
    if (window.location.hash && window.location.hash == '#cart-open') {
        $('body').on('cartDrawerLoaded', function(){
            theme.cartDrawer.drawer.open();
            window.location.hash = '';
        });
    }

    // ----------------------------------
    // SG, 2022-04-05
    // Handle Opinew app
    // ----------------------------------
    if ($("#opinew-plugin").length === 1) {
        (function() {
            var opwTexts = esn.getOpinewTexts(),
                $opwPlugin = $("#opinew-plugin"),
                loc = window.document.documentElement.lang,
                observer = new MutationObserver(function(mutations) {
                    $.each(mutations, function(i, m) {
                        var $fromReviews, $reviews, $res, $allLink, $widTab, $logoDesktop, $logoMobile, $reviewsTable, opwData, logoUrl;
                        if (m.target === $("div.opinew-widget-wrapper")[0] || m.target === $("div.summary-card-container")[1] && m.addedNodes.length == 1) {
                            //console.log("Opinew loaded");
                            let interval = setInterval(()=> {
                                $fromReviews = $opwPlugin.find(".opw-leading-loose.opw-text-base");
                                $reviews = $("div.opinew-widget-wrapper").find("div.review-card-container");
                                $res = $opwPlugin.find(".opw-pr-2");
                                $logoDesktop = $opwPlugin.find(".opw-logo.desktop");
                                $logoMobile = $opwPlugin.find(".opw-logo.mobile");
                                $allLink = $opwPlugin.find(".opw-pt-2 .opw-py-1");
                                $widTab = $opwPlugin.find("div.opw-widget-tab");
                                $reviewsTable = $opwPlugin.find(".opw-reviewsCardBorderColor.opw-pb-2");
                                opwData = $opwPlugin.data("opw-prodreviews");
                                logoUrl = $opwPlugin.data("amazon-logo");

                                if ($fromReviews.length == 1) {
                                    if (typeof opwData === 'object' && typeof opwData.product !== "undefined") {
                                        if ($fromReviews.length == 1 && typeof opwData.product.rating_number !== "undefined") {
                                            $fromReviews.text(opwTexts.from_reviews.format(opwData.product.rating_number));
                                        }
                                        if ($res.length == 1 && typeof opwData.product.average_rating !== "undefined") {
                                            $res.text(opwData.product.average_rating.toLocaleString(loc, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + " ");
                                        }

                                        if ($reviews.length > 0) {
                                            $.each($reviews, function(i, review) {
                                                modRev(review);
                                            });
                                        }

                                        if ($allLink.length == 1) {
                                            $allLink.text(opwTexts.all_reviews);
                                        }

                                        if ($widTab.length == 1) {
                                            $widTab.text(opwTexts.customer_reviews.format(opwData.product.review_number));
                                        }

                                        if ($logoDesktop.length == 0 && logoUrl.length != 0) {
                                            $fromReviews.after(`<img class="opw-logo desktop" width="100" src="${logoUrl}">`)
                                        }

                                        if ($logoMobile.length == 0 && logoUrl.length != 0) {
                                            $reviewsTable.after(`<img class="opw-logo mobile" width="100" src="${logoUrl}">`)
                                        }
                                    }
                                    clearInterval(interval);
                                }
                            }, 1000);
                        } else if (m.target === $("div.opw-reviews-container div.opw-flex.opw-flex-wrap")[0] && m.addedNodes.length == 1) {
                            //console.log("Review added");
                            $reviews = $("div.opinew-widget-wrapper").find("div.review-card-container");

                            let interval = setInterval(()=> {
                                if ($("div.opinew-widget-wrapper").length) {
                                    if ($reviews.length > 0) {
                                        $.each($reviews, function(i, review) {
                                            modRev(review);
                                        });
                                    }

                                    clearInterval(interval);
                                }
                            }, 1000)

                        } else if (m.target === $("div.opw-px-2.opw-w-full")[0] && m.addedNodes.length == 1) {
                            //console.log("Review added");
                            modRev(m.addedNodes[0]);
                        }
                    });
                    //console.log(mutations);
                });

            function modRev(el) {
                var $el = $(el),
                    $opwDate = $el.find(".opw-date-created"),
                    $opwVerified = $el.find(".opw-verified"),
                    dat, opts;

                if ($opwVerified.length == 1) {
                    $opwVerified.text(opwTexts.verified_purchase);
                }

                if ($opwDate.length == 1) {
                    parts = $opwDate.text().split("/");
                    if (parts.length === 3) {
                        for (var i = 0; i < parts.length; i++) {
                            parts[i] = parseInt(parts[i]) !== NaN ? parseInt(parts[i]) : 0;
                        }
                        dat = new Date(Date.UTC(parts[2], parts[1] - 1, parts[0], 12, 0, 0));
                        opts = { year: "numeric", month: "short", day: "numeric" };
                        $opwDate.text(dat.toLocaleDateString(loc, opts));
                    }
                }
            }

            observer.observe($("#opinew-plugin")[0], {
                childList: true,
                subtree: true
            });

            var myScrollIntoView = HTMLElement.prototype.scrollIntoView;
            HTMLElement.prototype.scrollIntoView = function () {
                if (typeof arguments[0] === "object") {
                    arguments[0] = {};
                }
                myScrollIntoView.apply(this, arguments);
                window.scrollBy(0, $("header").outerHeight() * -1);
            }

            $("span.opinew-no-reviews-stars-plugin").on("click", function() {
                $(window).on("scroll", function(){
                    $("#opinew-plugin")[0].scrollIntoView();
                    $(window).off("scroll");
                })
            });
        })();
    }

})();

$(document).ready(function () {
    var data,
        $button,
        i,
        bundleInfo = null,
        recalculate = null,
        discountCode,
        $discountCodeText = null,
        $slashedPriceLine = null,
        iCodeValid,
        iSettings,
        loc = window.document.documentElement.lang;

    // smooth scrolling
    jQuery('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                jQuery('html, body').animate({
                    scrollTop: target.offset().top - $("header").outerHeight()
                }, 1000);
                return false;
            }
        }
    });

    var exchangeDomesticMail = {
        domesticMail:  null,
        shopSettings: null,
        internationalMail: null,

        init: function() {
            // Impressum or page
            var currentPage = $('.template-page').length > 0 ? $('#shopify-section-page-contact-template') : $('.shopify-policy__body');
            this.shopSettings = esn.getShopSettings();
            this.domesticMail = this.shopSettings.email;
            this.internationalMail = this.shopSettings.email_international;
            var market = this.shopSettings.market;

            if (market == 'international' && currentPage.length > 0) {
                this.changeMailInternational(currentPage);
            }
        },

        /**
         * creates a NodeList of ALL elements of css-selector * in div.rte
         * loop over each element within the NodeList
         * * loop over each child of the element.childnodes and check
         * * if the child is a textnode and includes the domesticMail
         * * => if true, replaces the text
         * if the looped element is a link and its href contains the domesticMail
         * => if true, replace href
         */
        changeMailInternational: function() {
            let NodeElements = document.querySelectorAll("div.rte *")
            for (const element of NodeElements) {

              for (const child of element.childNodes) {
                if (child.nodeType === Node.TEXT_NODE && child.textContent.includes(this.domesticMail)) {
                  child.textContent = child.textContent.replaceAll(this.domesticMail, this.internationalMail)
                }
              }

              if (element.nodeName === "A") {
                let href = element.getAttribute("href")
                if (href && href.includes(this.domesticMail)) {
                  element.setAttribute("href", href.replaceAll(this.domesticMail, this.internationalMail))
                }
              }
            }
          },
    };

    exchangeDomesticMail.init();

    // announcement bar slider
    var announcementBar = {
        interval: null,
        announcementText: $('div.announcement span.announcement__text'),

        init: function(){
            var sesKey;

            if (this.announcementText.length && (sesKey = this.announcementText.attr('data-text'))) {
                var barSessionSettings = window.sessionStorage[sesKey];
                if (!barSessionSettings || barSessionSettings != 'hidden') {
                    this.initSlider();
                    this.setEventHandlers();
                }
            }
        },

        initSlider: function(){
            this.convertTextToHTML();
            this.setSliderAnimation();
        },

        convertTextToHTML: function(){
            var slideWrapper = this.announcementText.find('>div'),
                text = slideWrapper[0].innerText.trim();
            if (!text) {
                text = slideWrapper[0].textContent.trim();
            }
            if (!text) return;

            var texts = text.split('--');
            if (texts.length > 1) {
                slideWrapper[0].innerText = '';

                $(texts).each(function(i, text){
                    var slide = document.createElement('span');
                    slide.className = 'animated';

                    if (i > 0) {
                        slide.className += ' hide';
                    }

                    slide.innerText = text;
                    slideWrapper[0].appendChild(slide);
                });
            }
        },

        setSliderAnimation: function(){
            var slides = this.announcementText.find('span');
            if (!slides || !slides.length) return;

            var i = 0;
            this.interval = setInterval(function(){
                var curSlide = $(slides[i]),
                    nextSlide = $(slides[i+1]);

                if (!nextSlide || !nextSlide.length) {
                    nextSlide = $(slides[0]);
                }

                curSlide.addClass('slideOutLeft');

                nextSlide.removeClass('hide');
                nextSlide.addClass('slideInRight');

                setTimeout(function(){
                    curSlide.addClass('hide');
                    curSlide.removeClass('slideOutLeft');

                    nextSlide.removeClass('slideInRight');
                }, 1000);

                i++;
                if (i >= slides.length) {
                    i = 0;
                }
            }, 4000);
        },

        setEventHandlers: function(){
            var self = this;

            $('body').on('announcement_bar.close', function(){
                clearInterval(self.interval);
            });
        }
    };

    announcementBar.init();

    // --------------------------------------------------------------------------------------
    // Use Customer Privacy API
    // --------------------------------------------------------------------------------------
    window.Shopify.loadFeatures(
        [
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
        ],
        error => {
            if (error) {
                console.log(error);
            }
        },
    );

    $(window).on("CookiebotOnConsentReady", function() {
        var c = Cookiebot.consent,
            p = c.preferences,
            s = c.statistics,
            m = c.marketing,
            tracking = p && s && m ? true : false;

        if (typeof window.Shopify.customerPrivacy !== "undefined"
            && typeof window.Shopify.customerPrivacy.userCanBeTracked === "function"
            && tracking != window.Shopify.customerPrivacy.userCanBeTracked()) {
            window.Shopify.customerPrivacy.setTrackingConsent(tracking, function() {
                //console.log({"Cookiebot.consent": c, "tracking": tracking, "userCanBeTracked": window.Shopify.customerPrivacy.userCanBeTracked()});
            });
        }
    });

    if ($("#renew_consent").length > 0) {
        $("#renew_consent").on("click", function(ev){
            ev.preventDefault();
            if (typeof Cookiebot === "object" && typeof Cookiebot.renew === "function") {
                Cookiebot.renew();
            }
        });
    }

    // Open first menu item of mobile nav
    $button = $($("#NavDrawer .mobile-nav .mobile-nav__item .mobile-nav__has-sublist button")[0]);
    if ($button.length > 0) {
        $button.trigger("click");
    }


    // on collection page
    if (typeof meta !== "undefined" && typeof meta.page !== "undefined" && typeof meta.page.pageType !== "undefined" && meta.page.pageType == "collection") {
        // --------------------------------------------------------------------------------------
        // Run AJAX reload on collection page sub links for desktop only
        // --------------------------------------------------------------------------------------
        if (window.innerWidth >= 768) {
            $("ul.tags.tags--vertical a.js-no-transition").each(function(i) {
                    if (!$(this).hasClass("no-ajax")) {
                        $(this).addClass("no-ajax");
                    }
                }
            );
        }
    }

    // on collection or homepage
    if (typeof meta !== "undefined" && typeof meta.page !== "undefined" && typeof meta.page.pageType !== "undefined" && (meta.page.pageType == "collection" || meta.page.pageType == "home" || meta.page.pageType == "page" && window.location.pathname.indexOf('/influencer/') >= 0)) {
        // --------------------------------------------------------------------------------------
        // show/hide promotion sales prices (slashed price line)
        // --------------------------------------------------------------------------------------
        function updateSlashedPriceCollection() {
            var code = esn.getCookie('discount_code'),
                action = null,
                isValidICode = false;

            const TOGGLE = 1,
                  SHOW_FORCE = 2,
                  HIDE = 3,
                  NONE = 4;

            // determine what action to take next:
            // show sale prices:
            //    1: for regular collections, only show sale prices if a valid discount code was applied and sales prices are currently hidden
            //    2: for promotion collections (handle 'aktion' and 'aktion2'), always show sale prices immediately on page
            //       load regardless of applied discount code
            // 3: hide shown sale prices if:
            //    - no code was entered and there are currently sales elements being shown
            // 4: do nothing if:
            //    - no code was entered and elements are already hidden
            action = NONE;
            var hidden = $('.grid-product__price--original:not(.hidden, .on-sale)').length === 0,
                shopSettings = esn.getShopSettings();
            if (shopSettings && shopSettings.collection_is_promo) {
                if (hidden) {
                    action = SHOW_FORCE;
                }
            } else {
                if (!code && !hidden) {
                    action = HIDE;
                } else if (code) {
                    action = TOGGLE;
                }
            }

            if (action && action === NONE) return;

            // icodes are irrelevant on promotion collection
            if (action !== SHOW_FORCE) {
                var iCodes = iSettings ? iSettings : esn.getISettings();

                if (iCodes && iCodes.icodes) {
                    iCodes = iCodes.icodes;
                }
                isValidICode = iCodes.length && $.inArray(code, iCodes) >= 0;
            }

            $('.grid__item.grid-product').each(function(i, gridItem) {
                var data = $(gridItem).find('.grid_slashed_price_line_data');
                if (data.length) {
                    var onSale = $(gridItem).find('.grid-product__price--original.on-sale').length,
                        proceed = false,
                        hide = false,
                        found = false,
                        codeConfig;
                    data = JSON.parse(data.html());
                    $(data).each(function(i, singleCodeConfig) {
                        if ((action === SHOW_FORCE || action === TOGGLE) && !isValidICode && (singleCodeConfig.disc_type == 'pub' || singleCodeConfig.disc_type == 'spec')) {
                            proceed = true;
                            if ($.inArray(code, singleCodeConfig.disc_cds) >= 0) {
                                hide = false;
                                found = true;
                            } else {
                                hide = action === TOGGLE;
                                if (action === SHOW_FORCE) {
                                    found = true;
                                }
                            }
                        } else if (action === HIDE || (action !== SHOW_FORCE && isValidICode && singleCodeConfig.disc_type == 'infl')) {
                            proceed = true;
                            found = true;
                            // for the "buy 4 pay 3" gratis promo, we want to show infl discounts only if total cart count is below
                            // the configured threshold
                            /*
                            if (singleCodeConfig.disc_appl == 'free_quant' && singleCodeConfig.quant) {
                                if (cart && cart.item_count >= singleCodeConfig.quant) {
                                    hide = true;
                                }
                            }
                            */
                        } else if (action === HIDE || (action === SHOW_FORCE && singleCodeConfig.disc_type == 'infl_spec') || (action !== SHOW_FORCE && isValidICode && singleCodeConfig.disc_type == 'infl_spec' && $.inArray(code, singleCodeConfig.disc_cds) >= 0)) {
                            proceed = true;
                            found = true;
                        }

                        codeConfig = singleCodeConfig;

                        if (found) return false; // break
                    });

                    // hide shown sale prices if no matching promotion config was found
                    if (!proceed && !isValidICode && action === TOGGLE) {
                        var hidden = $(gridItem).find('.grid-product__price--original:not(.hidden, .on-sale)').length === 0;
                        if (!hidden && codeConfig) {
                            proceed = true;
                            hide = true;
                        }
                    }

                    if (!proceed || !codeConfig) return;

                    var saleBadge = $(gridItem).find('.grid-product__tag.grid-product__tag--sale');
                    if (action === HIDE || hide) {
                        $(gridItem).find('.grid-product__tag.grid-product__tag--sale:not(.on-sale)').addClass('hidden');
                        $(gridItem).find('.grid-product__price span:not([data-sale-class], .on-sale)').addClass('hidden');
                    } else {
                        if (saleBadge.length) {
                            // if product is on sale, calculate % diff manually
                            if (onSale) {
                                saleBadge.text('-' + Math.round((1 - codeConfig.discount_price_raw / codeConfig.compare_price_raw) * 100) + '%');
                            } else {
                                saleBadge.text('-' + codeConfig.disc_perc + '%');
                            }
                        }
                        saleBadge.removeClass('hidden');

                        var price = $(gridItem).find('.grid-product__price');
                        if (price.length) {
                            price.find('.hidden').each(function(i, ele) {
                                $(ele).removeClass('hidden');
                            });
                        }
                    }

                    var salePrice = price ? price.find('span[data-sale-class]') : $(gridItem).find('.grid-product__price span[data-sale-class]');
                    if (salePrice.length) {
                        // split text to retain prefix (i. e. "ab €X")
                        var origText = salePrice.text().trim().split(' '),
                            newPrice = null;

                        if (action === HIDE || hide) {
                            newPrice = codeConfig.slashed_price;
                            if (!onSale) {
                                salePrice.removeClass(salePrice.attr('data-sale-class'));
                            } else {
                                saleBadge.text('-' + saleBadge.attr('data-saved-amount'));
                            }
                        } else {
                            newPrice = codeConfig.discount_price;
                            salePrice.addClass(salePrice.attr('data-sale-class'));
                        }

                        salePrice.text(origText.length > 1 && isNaN(parseFloat(origText[1]))? origText[0] + ' ' + newPrice : newPrice);
                    }
                }
            });
        }

        /*
        // is executed on page load and cart update
        $('body').on('updateCart.ajaxcart', function(event, cart){
            updateSlashedPriceCollection(cart);
        });
        */

        // additional event handler for empty cart
        $(window).on('discount_code.changed', function(){
            updateSlashedPriceCollection();
        });
        updateSlashedPriceCollection();
    }

    // --------------------------------------------------------------------------------------
    // Google Analytics Enhanced Ecommerce page view
    // --------------------------------------------------------------------------------------
    setPageDataLayer = function(data) {
        // Hier dataLayer für product pageview befüllen
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            "event": "detail",
            "ecommerce": {
                "currencyCode": Shopify.currency && Shopify.currency.active ? Shopify.currency.active : "EUR",
                "detail": {
                    "actionField": {},
                    "products": [{
                        "name": data.title,
                        "id": data.handle,
                        "sku": data.sku,
                        "price": data.price / 100,
                        "brand": data.vendor,
                        "category": data.type,
                        "variant": ""
                    }]
                }
            }
        });
    };

    // --------------------------------------------------------------------------------------
    // Some things on product page
    // - Google Analytics Enhanced Ecommerce page view
    // - Set Influencer-Code if element with id discount_code is found
    // --------------------------------------------------------------------------------------
    if (typeof meta !== "undefined" && typeof meta.product !== "undefined" && typeof meta.product.id !== "undefined" && meta.product.id > 0) {
        // Store product data to be used later
        var prodPage = true,
            initialDiscountCodeText = null,
            $productSection = $('.product-section');
        data = document.getElementById('ProductJson-1');

        if (data) {
            data = JSON.parse(data.innerHTML);
            setPageDataLayer(data);
        }

        // show slashed price line
        function showDiscountPrices() {
            var iSettings = esn.getISettings(),
                validCodes = iSettings ? iSettings.icodes.map(function(e){return e;}) : [],
                splData = (splData = $('#slashed_price_line_data')).length ? JSON.parse(splData.html()) : null,
                $discountCodeText = $("#discount_code_text"),
                $redeemNote = $("#redeem_note"),
                $codeNote = $("#code_note");

            $(splData).each(function() {
                if (this.disc_cds && (this.disc_type == 'pub' || this.disc_type == 'spec')) {
                    $(this.disc_cds).each(function(i, code){
                        validCodes.push(code);
                    });
                }
            });

            var codeValid = (discountCode = esn.getCookie("discount_code")) && validCodes.length && $.inArray(discountCode.toLowerCase(), validCodes) >= 0;

            if (($slashedPriceLine = $("#slashed_price_line")).length) {
                if (!initialDiscountCodeText) {
                    initialDiscountCodeText = $discountCodeText.text();
                }

                if ($slashedPriceLine.hasClass("hiddeni") && codeValid) {
                    $discountCodeText.text(discountCode.toUpperCase());
                    $slashedPriceLine.removeClass("hiddeni");
                }
                else if (!$slashedPriceLine.hasClass("hiddeni")) {
                    if (codeValid) {
                        $discountCodeText.text(discountCode.toUpperCase());
                        $redeemNote.addClass('hidden');
                        $codeNote.addClass('hidden');
                    }
                    else {
                        if ($redeemNote.length) {
                            $codeNote.removeClass("hidden");
                            $redeemNote.removeClass("hidden");
                            $discountCodeText.text(initialDiscountCodeText);
                        } else {
                            $slashedPriceLine.addClass('hiddeni');
                        }
                    }
                    $("#discount_code_info").removeClass("sr-text");
                }

                if (($pricePerServing = $(".serving__wrapper")).length) {
                    if (!$pricePerServing.hasClass('hiddeni')) {
                        if (codeValid) {
                            $('.serving__price').addClass('strikethrough');
                            $('.serving__price-discount').removeClass('hidden');
                        } else {
                            $('.serving__price').removeClass('strikethrough');
                            $('.serving__price-discount').addClass('hidden');
                        }
                    }
                }
            }
        }

        // update discount prices
        function triggerSlashedPriceUpdate() {
            updateSlashedPriceProduct();
            updatePricePerServing();
            showDiscountPrices();
        }

        $(window).on('discount_code.changed', function(){
             triggerSlashedPriceUpdate();
        });

        // a few things to do on each variant change:
        $('.product-single__variants').on('change', function(){
            // show related influencer quote of that variant
            showInflQuote();

            // update the "Omnibus" last price info
            updateLastPrice();

            updateSlashedPriceProduct();

            updatePricePerServing(this);

            // update discount price displays
            showDiscountPrices();
        });

        // execute on page load as well
        triggerSlashedPriceUpdate();

        // ---------------------------------------
        // AM, 2022-01-28
        // change "Analyses"-tab contents on variant change
        // ---------------------------------------
        $productSection.on('variantChange', function(event){
            if (esn.getShopSettings().analyses_display_type != 'Alle') {
                var variantLinks = $('div.collapsible-content .collapsible-content__inner .pdp_pdf_list a'),
                    analysesButton = $('button.collapsible-trigger[aria-controls=' + variantLinks.parents('div.collapsible-content')[0].id + ']'),
                    found = false;

                variantLinks.each(function(){
                    if (this.getAttribute('data-variant-id') == event.variant.id) {
                        $(this).removeClass('hide');
                        found = true;
                    }
                    else {
                        $(this).addClass('hide');
                    }
                });

                // automatic handling of the tab button depending on current state
                if (!found) {
                    // close before disabling
                    if (analysesButton.hasClass('is-open')) {
                        analysesButton.click()
                    }

                    analysesButton.prop('disabled', true);
                } else {
                    analysesButton.prop('disabled', false);

                    // re-open the tab if it is already opened
                    if (analysesButton.hasClass('is-open')) {
                        analysesButton.click().click();
                    }
                }
            }
        });

        // on initial page load, every PDF link is hidden, unhide the correct ones:
        var variantLinks = $('div.collapsible-content .collapsible-content__inner .pdp_pdf_list a.visible');
        variantLinks.each(function(){
            $(this).removeClass('hide visible');
        });

        // ---------------------------------------
        // AM, 2022-04-27
        // handle "frequently bought together" block on product page
        // ---------------------------------------
        var fbtManager = {
            form: $('#fbt_form'),
            error: $('.fbt_error'),
            imageList: $('.fbt_product_images'),
            //hiddenSymbols: [],
            fadeIntervals: [],

            init: function(){
                this.setEventHandlers();
            },

            // update total sum based on currently active rows and selected variants
            updateTotal: function(){
                var oldTotal = $('.fbt_price_total .money'),
                    newTotal = 0;
                $('.fbt_product_list li:not(.disabled) .fbt_variant_select, .fbt_product_list li:not(.disabled) .fbt_variant_input').each(function(){
                    if (this.nodeName == 'SELECT') {
                        newTotal += parseInt(this.selectedOptions[0].getAttribute('data-price'));
                    } else {
                        newTotal += parseInt(this.getAttribute('data-price'));
                    }
                });
                $(oldTotal).text(theme.Currency.formatMoney(newTotal, esn.getMoneyFormat()));
            },

            hideError: function(){
                this.error.addClass('hide');
                //this.imageList.removeClass('hide');
            },

            showError: function(){
                //this.imageList.addClass('hide');
                this.error.removeClass('hide');
            },

            setEventHandlers: function(){
                var self = this;

                // on variant change, update product images, prices and links
                $('.fbt_variant_select').on('change', function(){
                    var selOption = this,
                        parentLi = $(this).parents('li'),
                        relatedImg = $('li.fbt_product_image_container[data-id=' + parentLi.attr('data-id') + ']');

                    // update row price
                    var oldPrice = parentLi.find('.fbt_price .money');
                    $(oldPrice).text(theme.Currency.formatMoney(this.selectedOptions[0].getAttribute('data-price'), esn.getMoneyFormat()));

                    // update total sum
                    self.updateTotal();

                    // update product link to selected variant
                    var a = relatedImg.find('a'),
                        href = a.attr('href').split('?variant')[0];
                    a.attr('href', href + '?variant=' + this.selectedOptions[0].value);

                    // update image with animation
                    if (selOption.selectedOptions[0].getAttribute('data-image')) {
                        var img = relatedImg.find('img');
                        img.addClass('flipOutX');

                        setTimeout(function () {
                            img.attr('src', selOption.selectedOptions[0].getAttribute('data-image'));
                        }, 250);

                        img.on('load', function () {
                            img.removeClass('flipOutX');
                            img.addClass('flipInX');

                            setTimeout(function () {
                                img.removeClass('flipInX');
                            }, 350);
                        });
                    }
                });

                // on checkbox click, hide/show and disable/enable coupled elements
                $('.fbt_checkbox').on('click', function(){
                    var parentLi = $(this).parent('li'),
                        relatedImg = $('.fbt_product_image_container[data-id=' + parentLi.attr('data-id') + ']');

                    // clear timeouts if any were set recently
                    if (self.fadeIntervals[parentLi.attr('data-id')]) {
                        clearTimeout(self.fadeIntervals[parentLi.attr('data-id')]);
                    }

                    if (this.checked) {
                        // hide error if it's shown
                        self.hideError();

                        // show product image list if it's hidden
                        self.imageList.removeClass('hide');
                        $('.fbt_container_inner').removeClass('none');

                        // update row + show image
                        parentLi.removeClass('disabled');
                        relatedImg.removeClass('hide');
                        relatedImg.removeClass('fadeOut');
                        relatedImg.addClass('fadeIn');
                    } else {
                        var relatedImgSymbol = relatedImg.find('.fbt_plus_icon');

                        // update row + hide image
                        parentLi.addClass('disabled');
                        relatedImg.removeClass('fadeIn');
                        relatedImg.addClass('fadeOut');
                        relatedImgSymbol.addClass('fadeOut');
                    }

                    var activeImages = $('.fbt_product_image_container:not(.hide, .fadeOut)'),
                        symbol;

                    if (this.checked) {
                        // show plus symbols
                        // traverse backwards through DOM (starting from penultimate active image) until we find a non-hidden plus symbol
                        for(var i = 2; i <= activeImages.length; i++) {
                            if ($(activeImages[activeImages.length - i])) {
                                if (!symbol || !symbol.length) {
                                    symbol = $(activeImages[activeImages.length - i]).find('.fbt_plus_icon.hide, .fbt_plus_icon.fadeOut');
                                }
                            }
                        }

                        if (symbol && symbol.length) {
                            symbol.removeClass('hide');
                            symbol.removeClass('fadeOut');
                            symbol.addClass('fadeIn');
                        }

                        self.fadeIntervals[parentLi.attr('data-id')] = setTimeout(function(){
                            relatedImg.removeClass('fadeIn');
                            if (symbol && symbol.length) {
                                symbol.removeClass('fadeIn');
                            }
                        }, 500);

                        // enable inputs
                        parentLi.find('input:not([type=checkbox]), select').removeAttr('disabled');
                    } else {
                        // hide plus symbols
                        if (activeImages.length) {
                            symbol = $(activeImages[activeImages.length - 1]).find('.fbt_plus_icon');
                        }

                        if (symbol && symbol.length) {
                            symbol.removeClass('fadeIn');
                            symbol.addClass('fadeOut');
                        }

                        self.fadeIntervals[parentLi.attr('data-id')] = setTimeout(function(){
                            relatedImg.addClass('hide');
                            relatedImg.removeClass('fadeOut');
                            relatedImgSymbol.addClass('hide');
                            relatedImgSymbol.removeClass('fadeOut');

                            if (symbol && symbol.length) {
                                symbol.addClass('hide');
                                symbol.removeClass('fadeOut');
                            }

                            if (!activeImages.length) {
                                self.imageList.addClass('hide');
                                $('.fbt_container_inner').addClass('none');
                            }
                        }, 500);

                        // disable inputs
                        parentLi.find('input:not([type=checkbox]), select').attr('disabled', 'disabled');
                    }

                    self.updateTotal();
                });

                // form submit
                this.form.submit(function(e){
                    e.preventDefault();

                    var data = self.form.serialize();
                    if (!data) {
                        self.showError();
                        return;
                    }

                    // start button loading animation
                    var formButton = self.form.find('.fbt_form_button'),
                        buttonWidth = formButton.width();
                    formButton.width(buttonWidth);
                    formButton.addClass('btn--loading');

                    $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: data,
                        dataType: "json",
                        success: function(data) {
                          let product = data
                          $('body').trigger('added.ajaxProduct', [formButton, product]);
                        },
                        complete: function() {
                            // stop button loading animation
                            formButton.removeClass('btn--loading');
                            formButton.width('');
                        }
                    });
                });
            }
        };

        fbtManager.init();

        // ---------------------------------------
        // AM
        // Omnibus-guidelines: show "last price" of selected variant if there is a sale
        // ---------------------------------------
        function updateLastPrice(){
            var price = $('.product-single__meta > .product__price'),
                slashedPrice = $('.slashed_price_line'),
                lastPriceEle = $('.ob_last_price');

            if (!lastPriceEle.length) return;

            // check if a sale price is being shown
            if (price.hasClass('sale-price') || (slashedPrice.length && !(slashedPrice.hasClass('hiddeni') || slashedPrice.hasClass('hidden')))) {
                var select = $('.product-single__variants');

                if (!select.length) return;

                var lastPrice = select[0].selectedOptions[0].getAttribute('data-price');

                if (lastPrice) {
                    lastPriceEle.find('span').text(theme.Currency.formatMoney(parseFloat(lastPrice), esn.getMoneyFormat()));
                    lastPriceEle.removeClass('hide');
                } else {
                    lastPriceEle.addClass('hide');
                }
            } else {
                lastPriceEle.addClass('hide');
            }
        }

        updateLastPrice();
        // ---------------------------------------
        // JS
        // check validConfig
        // ---------------------------------------
        function getValidConfig(splData) {
            var validConfig = null;
            code = esn.getCookie('discount_code'),
            iCodes = iSettings ? iSettings : esn.getISettings();

            $(splData).each(function() {
                if ((this.disc_type == 'pub' || this.disc_type == 'spec') && (!code || $.inArray(code, this.disc_cds) >= 0)) {
                validConfig = this;
                } else if (this.disc_type == 'infl') {
                if (iCodes && iCodes.icodes) {
                    iCodes = iCodes.icodes;
                }
                if (iCodes.length && $.inArray(code, iCodes) >= 0) {
                    validConfig = this;
                }
                } else if (this.disc_type == 'infl_spec' && code && $.inArray(code, this.disc_cds) >= 0) {
                validConfig = this;
                }

                if (validConfig) {
                return false; // break
                }
            });

            return validConfig;
        }
        // ---------------------------------------
        // AM
        // update price per serving of selected variant. only necessary on variant change.
        // ---------------------------------------
        function updatePricePerServing(select) {
            if (!select) {
                select = $('.product-single__variants')[0];
            }

            if (select.selectedOptions.length) {
                var pps = parseFloat(select.selectedOptions[0].getAttribute('data-serving-price')),
                    wrapper = $('.serving__wrapper'),
                    price = wrapper.find('.serving__price'),
                    splData = (splData = $('#slashed_price_line_data')).length ? JSON.parse(splData.html()) : null;

                if (pps) {
                    pps = Math.round(pps);
                    wrapper.removeClass('hiddeni');
                    price.text(theme.Currency.formatMoney(pps, esn.getMoneyFormat()));
                    if (splData) {
                        var validConfig = getValidConfig(splData);

                        if (!validConfig) {
                            validConfig = splData[0];
                        };
                        // calculate + set discount price
                        var discPerc = validConfig.disc_perc;
                        var discPrice = wrapper.find('.serving__price-discount');
                        discPrice.text(theme.Currency.formatMoney(pps * (1 - discPerc / 100), esn.getMoneyFormat()));
                    }
                } else {
                    wrapper.addClass('hiddeni');
                }
            }
        }

        // ---------------------------------------
        // AM
        // update slashed price line price based on selected variant
        // ---------------------------------------
        function updateSlashedPriceProduct(select) {
            if (!select) {
                select = $('.product-single__variants')[0];
            }
            if (select.selectedOptions.length) {
                var pps = parseFloat(select.selectedOptions[0].getAttribute('data-price'));
                var splData = (splData = $('#slashed_price_line_data')).length ? JSON.parse(splData.html()) : null;
                if (pps) {
                    pps = Math.round(pps);
                    if (splData) {
                        var slashedPriceLine = $("#slashed_price_line");
                        if (slashedPriceLine) {
                            var slashedPrice = slashedPriceLine.find('.sp_sld902mn5x'),
                                discountPrice = slashedPriceLine.find('.dp_x8jg2og3s'),
                                validConfig = null;

                            var validConfig = getValidConfig(splData);

                            if (validConfig) {
                                var discPerc = validConfig.disc_perc;
                                slashedPrice.text(theme.Currency.formatMoney(pps), esn.getMoneyFormat());
                                discountPrice.text(theme.Currency.formatMoney(pps * (1 - discPerc / 100), esn.getMoneyFormat()));
                            }
                        }
                    }
                }
            }
        }

        // ---------------------------------------
        // AM
        // Show influencer quotes on PDP. If set, shows quotes related to specific variants (or the main product as a fallback).
        // ---------------------------------------
        function showInflQuote() {
            var data = document.getElementById("iquote_data"),
                select = $('.product-single__variants');

            if (!data || !select) return;

            var varId = select.val();
            quoteCont = $('.iquote_wrapper');
            data = JSON.parse(data.innerHTML);

            // check if data for that variant exists. if not, fall back to main product data
            if (!data[varId]) {
                varId = 'main';
            }

            // the data object contains only complete entries. if no entry for that key exists, there's nothing to show.
            if (data[varId]) {
                quoteCont.find('img').attr('src', data[varId].img);
                quoteCont.find('.iquote_handle').html(data[varId].name);
                quoteCont.find('.text_quote').html(data[varId].txt);
                if (quoteCont.hasClass('hide')) {
                    setTimeout(function () {
                        quoteCont.addClass('fadeIn');
                        quoteCont.removeClass('hide');
                        setTimeout(function () {
                            quoteCont.removeClass('fadeIn');
                        }, 200);
                    }, 250);
                }
            } else {
                quoteCont.removeClass('fadeIn');
                quoteCont.addClass('fadeOut');
                setTimeout(function(){
                    quoteCont.addClass('hide');
                    quoteCont.removeClass('fadeOut');
                }, 200);
            }
        }

        showInflQuote();

        // move quote-container to other location within DOM for mobile views
        var quoteCont = $('.iquote_wrapper'),
            origPosition = true; // mark if the quote-wrapper is in its original position, as outputted on initial page load
        function moveInflQuote() {
            if (window.innerWidth < 590 && origPosition) {
                quoteCont.remove();
                quoteCont.insertBefore('.product-single__meta hr');
                //quoteCont.css('margin-top', '20px');
                origPosition = false;
            } else if (window.innerWidth >= 590 && !origPosition) {
                quoteCont.remove();
                $('.product-single__sticky').append(quoteCont);
                //quoteCont.css('margin-top', '');
                origPosition = true;
            }
        }

        // set resize observer to move quote-container
        $(window).on('resize', function(){
            moveInflQuote();
        });

        moveInflQuote();
    }

    // some things on cart page
    $('body').on('cartPageLoaded', function(){
        /* change how the delete buttons work - instead of following a link, manipulate the product form and submit it entirely.
           this change runs in accordance to some of our features that require a mutable cart in the Shopify line-items script */
        $('.cart__row .cart_delete').each(function(){
            $(this).on('click', function(e){
                e.preventDefault();

                $(this).addClass('btn--loading white');

                $(this).parents('.cart__row').find('input.cart__product-qty').val(0);
                $('form.cart button.cart__update').click();
            });
        });
    });

    // --------------------------------------------------------------------------------------
    // Opinew: Format rating numbers according to locale
    // --------------------------------------------------------------------------------------
    function frmtRatingNo($el){
        if ($el.find("span.opinew-no-reviews-stars-plugin b").length > 0) {
            $el.find("span.opinew-no-reviews-stars-plugin b").each(function(i){
                var txt = $(this).text().trim(), num;
                if (txt != "") {
                    txt = txt.replace(/[\.,\(\)]/g, '');
                    num = parseInt(txt);
                    if (!isNaN(num) && num > 0) {
                        txt = "(" + num.toLocaleString(loc, { maximumFractionDigits: 0 }) + ")";
                        $(this).text(txt);
                    }
                }
            });
        }
    }
    frmtRatingNo($("body"));
    $("body").on("recommendationsUpdated", function(){
        frmtRatingNo($("#shopify-section-product-recommendations"));
    });

    // --------------------------------------------------------------------------------------
    // Handle ESN bundles
    // --------------------------------------------------------------------------------------
    // Check, if we are on a bundle product page
    if (typeof meta !== "undefined" && typeof meta.product !== "undefined" && typeof meta.product.id !== "undefined" && meta.product.id > 0 && meta.product.type == "bundle") {
        if ($("#bundle_info").length == 1) {
            bundleInfo = JSON.parse(document.getElementById("bundle_info").innerHTML);
        }
        // Loop over bundle products
        $("div.bundle_row.group").each(function (i) {
            var $img = $(this).find("img.bundle_prod--img"),
                $sel = $(this).find("select"),
                $price = $(this).find("span.bundle_prod--price.group");
            if ($img.length > 0 && $sel.length > 0) {
                $sel.on("change", function() {
                    var $option = $(this).find("option:selected");
                    if ($option.length == 1) {
                        $img.attr("src", $option.attr("data-image"));
                        if ($price.length == 1) {
                            $price.text(theme.Currency.formatMoney($option.attr("data-price"), esn.getMoneyFormat()));
                        }
                        recalculate();
                    }
                });
            }
        });

        $(".js-qty__adjust").on("click", function () {
            $("#Quantity-" + bundleInfo.section_id).change();
        });

        if (bundleInfo !== null && bundleInfo.bundle_available) {
            $("#Quantity-" + bundleInfo.section_id).on("change", function(i) {
                var mult = parseInt($("#Quantity-" + bundleInfo.section_id).val()),
                    error = false;

                if (!isNaN(mult)) {
                    $("div.bundle_row.group").each(function (i) {
                        var $el = $(this).find("select"),
                            $quantity = $(this).find("span.bundle_prod--quantity"),
                            baseQuantity,
                            quantity;

                        if ($el.length == 0) {
                            $el = $(this).find("input");
                            if ($el.length == 0) {
                                error = true;
                                return false;
                            }
                        }
                        baseQuantity = $el.attr("data-quantity");
                        quantity = mult * baseQuantity;
                        if ($quantity.length == 0) {
                            error = true;
                            return false;
                        }
                        $quantity.text(quantity);
                    });
                    recalculate();
                }
            });
        }

        recalculate = function() {
            if (bundleInfo !== null && bundleInfo.bundle_available) {
                var
                    price = 0,
                    discPrice = 0,
                    error = false,
                    $price = null,
                    $discPrice = null;

                $("div.bundle_row.group").each(function (i) {
                    var $parentEl = $(this).find("select"),
                        $el = $parentEl.find("option:selected"),
                        $quantity = $(this).find("span.bundle_prod--quantity"),
                        quantity = 1,
                        pricePerUnit,
                        discPricePerUnit,
                        itemDisc,
                        discount;

                    if ($parentEl.length == 0 || $el.length == 0) {
                        $parentEl = $el = $(this).find("input");
                        if ($el.length == 0) {
                            error = true;
                            return false;
                        }
                    }
                    if ($quantity.length == 1) {
                        quantity = parseInt($quantity.text());
                        if (isNaN(quantity) || quantity <= 0) {
                            quantity = 1;
                        }
                    }
                    pricePerUnit = $el.attr("data-price");
                    discount = bundleInfo.discount;
                    itemDisc = $parentEl.attr("data-discount");
                    if (typeof(itemDisc) != "undefined" && itemDisc !== "" && !isNaN(parseFloat(itemDisc))) {
                        discount = parseFloat(itemDisc);
                    }
                    discPricePerUnit = Math.round((1 - discount/100) * pricePerUnit);
                    price += (pricePerUnit * quantity);
                    discPrice += (discPricePerUnit * quantity);
                });
                if (!error) {
                    $price = $("#ComparePrice-" + bundleInfo.section_id);
                    $discPrice = $("#ProductPrice-" + bundleInfo.section_id);
                    if ($price.length == 1) {
                        $price.text(theme.Currency.formatMoney(price, esn.getMoneyFormat()));
                    }
                    if ($discPrice.length == 1) {
                        $discPrice.text(theme.Currency.formatMoney(discPrice, esn.getMoneyFormat()))
                    }
                }
            }
        }
        recalculate();
    }

    $('.desc--bottom_btn').click(function(e) {
        e.preventDefault();
        jQuery('.desc--bottom').toggleClass('--open').slideDown("slow");
    });

    function queryToObj(query) {
        var json = {},
            push_counters = {},
            patterns = {
                "validate": /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
                "key":      /[a-zA-Z0-9_]+|(?=\[\])/g,
                "push":     /^$/,
                "fixed":    /^\d+$/,
                "named":    /^[a-zA-Z0-9_]+$/
            },
            q = decodeURIComponent(query),
            serialArr = [];

        $.each(q.split("&"), function(i, el) {
            var parts = el.split("="),
                name = parts[0],
                value = parts.length > 1 ? parts[1] : "";

            serialArr.push({name: name, value: value});
        });

        function build(base, key, value){
            base[key] = value;
            return base;
        }

        function push_counter(key){
            if(push_counters[key] === undefined){
                push_counters[key] = 0;
            }
            return push_counters[key]++;
        }

        $.each(serialArr, function(){
            // Skip invalid keys
            if(!patterns.validate.test(this.name)){
                return;
            }

            var k,
                keys = this.name.match(patterns.key),
                merge = this.value,
                reverse_key = this.name;

            while((k = keys.pop()) !== undefined){
                // Adjust reverse_key
                reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), '');
                // Push
                if(k.match(patterns.push)){
                    merge = build([], push_counter(reverse_key), merge);
                }
                // Fixed
                else if(k.match(patterns.fixed)){
                    merge = build([], k, merge);
                }
                // Named
                else if(k.match(patterns.named)){
                    merge = build({}, k, merge);
                }
            }
            json = $.extend(true, json, merge);
        });

        return json;
    }

    /**
     * Handles discount code management in the storefront (not checkout).
     * The aim of this is to have a central place for discount calculation, which is the line-items
     * checkout script. The checkout scripts are very encapsulated and more or less isolated from the
     * rest. Our only interface/way of communication is via line-item properties, which we use to relay
     * the entered discount code from the shop front-end to the line-items script. This object handles
     * the line-item property management whenever users interact with the cart outside of the checkout.
     */
    var discountCodeManager = {

        discountCode: null,
        shopSettings: null,
        dummyVariantId: null,
        validationApiUrl: null,
        cookieDomain: null,
        dcPropertyName: 'discount_code_cart',
        dcTypPropertyName: 'dc_typ',
        countryPropertyName: '_user_country',
        requestsFinished: 0,
        eventPrefix: 'discount_code',
        dcInput: $('#DiscountCodeCart'),
        dcButton: $('#DiscountCodeCartButton'),
        dcRemoveButton: $('.discount-code-icon-close'),
        cart: null,
        onCartPage: false,

        // "constants" (please dont change these)
        CART_ADD: 1,
        CART_CHANGE: 2,
        CART_UPDATE: 3,

        init: function(){
            if ((this.shopSettings = esn.getShopSettings()) && this.shopSettings.discount_code.preview && !this.getDisabledDcPreview()) {
                this.dummyVariantId = this.shopSettings.discount_code.dummy_id;
                this.validationApiUrl = this.shopSettings.discount_code.api_url;
                this.validation = this.shopSettings.discount_code.validation;
                this.cookieDomain = this.shopSettings.shop_domain.replace('www.','');
                this.discount_code_changeto = this.shopSettings.discount_code_changeto_by_env;
                this.discount_code_changedby = this.shopSettings.discount_code_changedby_by_env;
                this.setEventHandlers();
                this.updateCustomDcCookie();
                this.autoApplyDc();
                this.insertDcIntoInputField();
                this.resetAppliedDc();
                //this.reapplyDc();

                // cookie is set after switching country and remaining on same (sub)domain
                if (Cookies.get('add_discount_after_reload')) {
                  this.addDcDummyProduct();
                  Cookies.remove('add_discount_after_reload');
                }
            } else {
                // hide entire code input if feature is disabled
                this.hideDcPreview();
            }
        },

        getDiscountCode: function(){
            if (!this.discountCode) {
                this.discountCode = esn.getCookie("discount_code");
            }

            return this.discountCode;
        },

        setDiscountCode: function(code){
            this.discountCode = code;
        },

        getAppliedDc: function(){
            return Cookies.get("applied_discount_code");
        },

        setAppliedDc: function(code){
            return Cookies.set("applied_discount_code", code);
        },

        setCustomDcCookie: function(code){
            Cookies.set(this.discount_code_changeto, code, {domain: `${this.cookieDomain}`});
            Cookies.set(this.discount_code_changedby, window.location.host.replace('www.',''), {domain: `${this.cookieDomain}`});
        },

        // We have our own custom "discount_code" cookie, which applies to all region subdomains (in contrast to Shopify's
        // cookie, which applies to the current subdomain only). We use this custom cookie to automatically apply
        // an already entered discount code after the user changes regions (and hence gets redirected to a different subdomain)
        // in short: this enables persistent, cross-subdomain discount codes in the storefront
        //
        // This function is used to detect discount code changes through URL (/discount/XYZ)
        updateCustomDcCookie: function() {
            let dc,
                dcChangedBy = esn.getCookie(this.discount_code_changedby);

            if ((dc = this.getDiscountCode()) && (!dcChangedBy || window.location.host.replace('www.','') === dcChangedBy)) {
                let dcChangeTo = esn.getCookie(this.discount_code_changeto);
                if (/*dcChangeTo !== '' && */dcChangeTo !== dc) {
                    this.setCustomDcCookie(dc);
                }
            }
        },

        autoApplyDc: function(){
            let dcChangeTo;

            if (dcChangeTo = esn.getCookie(this.discount_code_changeto)) {
                let dc = this.getDiscountCode();
                if (dc !== dcChangeTo) {
                    this.applyDc(dcChangeTo);
                }
            // 'changeto' value can be empty string, indicating removal of discount code
            } /*else if (dcChangeTo === '') {
                this.dcRemoveButton.click();
            }
            */
        },

        getSessionCookie: function(){
            return Cookies.get("session_started");
        },

        setSessionCookie: function(val){
            return Cookies.set("session_started", val);
        },

        getDisabledDcPreview: function(){
            return Cookies.get("disable_discount_code_preview");
        },

        disableDcPreview: function(){
            var ret;

            this.hideDcPreview();
            ret = Cookies.set("disable_discount_code_preview", 1);
            $('body').trigger(this.eventPrefix + '.disabled');

            return ret;
        },

        // hide entire code input if feature is disabled
        hideDcPreview: function(){
            this.dcInput.closest('.discount-code-cart-wrapper').remove();
        },

        showDcPreviewError: function() {
            var htmlMsg = '<div class="discount-code-cart-wrapper appear-animation appear-delay-2"><div class="alert alert--warning"><div class="alert-close"><button type="button"><svg aria-hidden="true" focusable="false" role="img" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg><span class="icon__fallback-text">X</span></button></div><span class="error">' + $('<textarea/>').html(esn.getLocales().dc_preview_error).text() + '</span></div></div>',
                cartHeader = $("form.drawer__contents > div.drawer__fixed-header");

            cartHeader.after(htmlMsg);

            // discount code preview error msg close button
            $('.discount-code-cart-wrapper .alert .alert-close').on('click', function(){
                $(this).closest('.discount-code-cart-wrapper').remove();
            });
        },

        resetAppliedDc: function(){
            // reset applied_discount_code if discount_code is not set
            if (!this.getDiscountCode() && this.getAppliedDc()) {
                Cookies.remove("applied_discount_code");
            }
        },

        // re-apply set discount code after language switch
        /*
        reapplyDc: function(){
            var code = this.getDiscountCode();

            if (code && Cookies.get('reapply_dc')) {
                this.applyDc(code);
                Cookies.remove('reapply_dc');
            }
        },
        */

        cartLoaded: function(){
            return theme.cartDrawer.status.loaded;
        },

        startLoading: function(){
            this.dcButton.addClass('btn--loading');
            theme.cartDrawer.loading(true);
        },

        progressLoading: function() {
            this.requestsFinished++;
            if (this.requestsFinished >= 2 || this.cartIsEmpty()) {
                this.finishLoading();
            }
        },

        finishLoading: function(){
            this.dcButton.removeClass('btn--loading');
            theme.cartDrawer.loading(false);
            this.requestsFinished = 0;
            $('body').trigger(this.eventPrefix + '.finished_loading');
        },

        // insert discount cookie value into discount code input field
        insertDcIntoInputField: function(){
            if (this.getDiscountCode()) {
                this.dcInput.val(this.discountCode.toUpperCase());
                this.toggleDcRemoveButton(true);
            }
        },

        // inject hidden discount code input into /cart page form to transmit it to checkout
        appendDcToForm: function(){
            if (this.onCartPage) {
                var dcHiddenInput = $('input[type=hidden][name=discount]'),
                    form = $('form.cart'),
                    dc;

                if (dc = this.getDiscountCode()){
                    if (!dcHiddenInput.length) {
                        // create new
                        dcHiddenInput = document.createElement('input');
                        dcHiddenInput.setAttribute('type', 'hidden');
                        dcHiddenInput.setAttribute('name', 'discount');
                        dcHiddenInput.setAttribute('value', dc);
                        form.append(dcHiddenInput);
                    } else {
                        // change existing
                        dcHiddenInput.val(this.getDiscountCode());
                    }
                }
            }
        },

        // remove hidden discount code input from /cart page form
        removeDcFromForm: function(){
            if (this.onCartPage) {
                var dcHiddenInput = $('input[type=hidden][name=discount]');

                if (dcHiddenInput.length) {
                    dcHiddenInput.remove();
                }
            }
        },

        // returns true if the currently set discount code via cookie has been applied to cart
        dcApplied: function() {
            var appliedCode = this.getAppliedDc();

            return appliedCode && this.getDiscountCode() && appliedCode.toLowerCase() == this.discountCode.toLowerCase();
        },

        animateWrongCode: function() {
            var self = this;

            // invalid code
            this.dcInput.addClass('shake-animation wrong-code');
            this.dcRemoveButton.addClass('shake-animation');

            setTimeout(function(){
                self.dcInput.removeClass('shake-animation wrong-code');
                self.dcRemoveButton.removeClass('shake-animation');
            }, 1000);
        },

        // toggle the discount code remove button to show/hide
        toggleDcRemoveButton: function(show){
            var self = this;

            if (show == null) {
                show = this.dcRemoveButton.width() === 0;
            }

            if (show) {
                this.dcRemoveButton.show();
                this.dcInput.addClass('smaller-input');
                this.dcRemoveButton.width(30);
            } else {
                this.dcRemoveButton.width(0);
                this.dcInput.removeClass('smaller-input');
                setTimeout(function(){
                    self.dcRemoveButton.hide();
                }, 150);
            }
        },

        getCart: function() {
            return this.cart;
        },

        cartIsEmpty: function() {
            if (this.cartLoaded()) {
                if (this.cart) {
                    return this.cart.items.length === 0;
                } else { // fallback
                    return $('.ajaxcart__product').length === 0;
                }
            } else {
                return null;
            }
        },

        /**
         * checks if the destination of the given URL is cart/change, cart/add or cart/update
         * @param  {String} url  The URL to be checked
         * @return {Boolean|Int} Returns false if destination is neither, 1 if it is cart/add, 2 if cart/change and 3 if cart/update
         */
        getRequestType: function(url){
            var ret = false;

            if (url.indexOf("cart/add") >= 0) {
                return this.CART_ADD;
            } else if (url.indexOf("cart/change") >= 0) {
                return this.CART_CHANGE;
            } else if (url.indexOf("cart/update") >= 0) {
                return this.CART_UPDATE;
            }

            return ret;
        },

        reqDataHasDcProperty: function(data){
            return data.indexOf(this.dcPropertyName) >= 0;
        },

        reqWasModified: function(settings){
            return settings['modified'];
        },

        // update cart drawer via API or refresh site if on cart page
        updateCart: function(){
            var doUpdate = true;

            // reload if on cart page to see newly applied discounts take effect
            if (window.location.pathname.indexOf('/cart') >= 0) {
                // if cart drawer is currently open, refresh on close
                if ($('#CartDrawer').hasClass('drawer--is-open')) {
                    $('body').on('drawerClose', function(){
                        location.reload();
                    });
                } else {
                    // if cart drawer is not open, reload immediately
                    doUpdate = false;
                    location.reload();
                }
            }

            if (doUpdate) {
                theme.cart.getCart().then(function(cart) {
                    theme.cartDrawer.updateSuccess(cart);
                    theme.cartDrawer.loading(false);
                });
            }
        },

        /**
         * Performs check to see if a saved cart from a previous session needs to be updated.
         * This is the case if a user's cart contains discounted articles, but the discount_code cookie is not set for this session.
         * This check is performed only once during a session.
         */
        updateSavedCart: function(){
            if (!this.getDiscountCode() && !this.getSessionCookie() && !this.cartIsEmpty()) {
                if ($('.cart__discount').length) {
                    this.recalcCart();
                }
            }

            if (!this.getSessionCookie()) {
                this.setSessionCookie(1);
            }
        },

        // force new cart calculation by sending current note
        recalcCart: function(callback = null){
            var note = (note = $('textarea[name="note"]').val()) ? note : '';

            if (callback == null) {
                callback = this.updateCart;
            }

            $.post({
                url:'/cart/update.js',
                data:'note=' + note,
                dataType: "json",
                modified: true
            }).then(callback);
        },

        /**
         * Adds the discount code dummy product to cart via API.
         *
         * @param {function} callback The function to call via .then() after sending the "add" request. Pass false to disable any callbacks.
         */
        addDcDummyProduct: function(callback = null){
            if (this.getDisabledDcPreview()) return false;

            var dc = this.getDiscountCode();
            if (!dc) return false;

            if (callback == null) {
                callback = this.updateCart;
            }

            var data = {items:[{
                    id: this.dummyVariantId,
                    quantity: 1,
                    properties:{}
                }]};

            data['items'][0]['properties'][this.dcPropertyName] = dc;
            data['items'][0]['properties'][this.countryPropertyName] = this.shopSettings.country.toUpperCase();
            if ($.inArray(dc.toLowerCase(), this.shopSettings.isettings.icodes) >= 0) {
                data['items'][0]['properties'][this.dcTypPropertyName] = "infl";
            }

            $.post({
                url: '/cart/add.js',
                dataType: 'json',
                data: data,
                modified: true,
            }).then(callback);
        },

        sanitizeDc: function(code) {
            if (code) {
                return code.trim().toLowerCase();
            }
        },

        checkDc: function(code) {
            if (code && code.length && code != '') {
                if (code.match(/^[a-zA-Z0-9.\-_: ]*$/)) {
                    return true;
                }
            }

            return false;
        },

        validateAndApplyDc: function(code){
            var self = this;

            this.startLoading();

            if (!this.validation) {
                self.applyDc(code);
            } else {
                // perform API call to check if code is actually valid
                $.post({
                    url: this.validationApiUrl + code,
                    dataType:'json',
                    type: 'GET',
                }).then(function(resp){
                    // resp.valid is always false currently
                    if (resp && (self.shopSettings.myshopify_domain == self.shopSettings.shop_domain || resp.valid)) {
                        self.applyDc(code);
                    } else {
                        self.animateWrongCode();
                        self.finishLoading();
                    }
                });
            }
        },

        /**
         * Sets the discount code via a special discount code dummy product and setting a line-item property for it.
         * A code is considered applied when the dummy product was successfully added to the cart with the line-item
         * property "discount_code_cart" set.
         * 2 simultaneous async requests are sent, 1 to set the cookie via the /discount/ route, the other
         * to cart/add.js to add the dummy product.
         */
        applyDc: function(code){
            var self = this;

            $.ajax('/discount/' + encodeURIComponent(code)).then(function(){
                self.progressLoading();
                self.toggleDcRemoveButton(true);
                self.setCustomDcCookie(code);
                $(window).trigger(self.eventPrefix + '.changed', code);
            });

            this.setDiscountCode(code);

            if (!self.cartIsEmpty()) {
                this.addDcDummyProduct(function() {
                    self.updateCart();
                    self.progressLoading();
                    self.setAppliedDc(self.discountCode);
                    self.appendDcToForm();
                    $('body').trigger(self.eventPrefix + '.applied', code);
                });
            }
        },

        setEventHandlers: function(){
            var self = this;

            // discount code apply button click
            this.dcButton.on('click', function(){
                var code;

                if (code = self.sanitizeDc(self.dcInput.val())) {
                    if (self.checkDc(code)) {
                        self.validateAndApplyDc(code);
                    }
                    else {
                        self.animateWrongCode();
                    }

                    // insert sanitized code into input field
                    self.dcInput.val(code.toUpperCase());
                }
            });

            // discount code input field enter key = apply
            this.dcInput.on('keydown', function(e){
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();
                    if (this.value) {
                        self.dcButton.click();
                    }
                }
            });

            // 'remove code' button
            this.dcRemoveButton.on('click', function(){
                // delete cookies
                Cookies.remove("discount_code");
                //Cookies.set(self.shopSettings.discount_code_changeto_by_env, '', {domain: `${self.cookieDomain}`});
                Cookies.remove(self.shopSettings.discount_code_changeto_by_env, {domain: `${self.cookieDomain}`});
                Cookies.remove(self.shopSettings.discount_code_changedby_by_env, {domain: `${self.cookieDomain}`});
                Cookies.remove("applied_discount_code");
                self.discountCode = null;

                // empty input
                self.dcInput.val('');

                self.removeDcFromForm();

                // force cart recalculation by sending note
                if (!self.cartIsEmpty()) {
                    self.recalcCart();
                }

                // hide the remove button
                self.toggleDcRemoveButton(false);
                $('body').trigger(self.eventPrefix + '.remove_button_hidden');
                $(window).trigger(self.eventPrefix + '.changed', null);
            });

            /**
             * Generic jquery ajax send event, fired before request is sent.
             * This event is used to capture certain requests so that we can add our discount code dummy product to the cart.
             *
             * @param {obj} event    The event object
             * @param {obj} jqxhr    The request object
             * @param {obj} settings The original request config, contains url, data, etc.. Modifying this will change the original request
             */
            $(document).ajaxSend(function(event, jqxhr, settings){
                var type;

                // check if we need to add discount code dummy product to request
                if (settings.data && (type = self.getRequestType(settings.url)) && self.getDiscountCode() && !self.reqWasModified(settings) && !self.reqDataHasDcProperty(settings.data) && !self.getDisabledDcPreview()) {

                    if (type) {
                        settings['modified'] = true;
                    }

                    if (type === self.CART_ADD) {

                        var dataObj = queryToObj(settings.data),
                            properties = {},
                            data = {items:[]};

                        properties[self.dcPropertyName] = self.discountCode;
                        properties[self.countryPropertyName] = self.shopSettings.country.toUpperCase();
                        if ($.inArray(self.discountCode.toLowerCase(), self.shopSettings.isettings.icodes) >= 0) {
                            properties[self.dcTypPropertyName] = "infl";
                        }

                        // check if we are dealing with one or multiple items (bundles)
                        if (typeof dataObj.items !== 'undefined') {
                            // multiple items
                            $.each(dataObj.items, function(i, item){
                                if (item) {
                                    data.items.push(item);
                                }
                            });

                            data.items.push({id: self.dummyVariantId, quantity: 1, properties: properties});
                            settings.data = $.param(data);
                        } else {
                            // single item
                            data.items.push({id: dataObj.id, quantity: dataObj.quantity});
                            data.items.push({id: self.dummyVariantId, quantity: 1, properties: properties});
                            settings.data = $.param(data);
                        }

                        self.setAppliedDc(self.discountCode);

                    } else if(type === self.CART_CHANGE || (type == self.CART_UPDATE && typeof settings.data == 'string' && settings.data.indexOf("note") !== 0)) {

                        // stop request
                        jqxhr.abort();

                        // upon aborting request, cart is not being shown as loading anymore, so we fix this:
                        setTimeout(function(){
                            theme.cartDrawer.loading(true);
                        }, 50);

                        /* Total of 3 requests are sent here, due to technical limitations it seems there's no other way to
                           do this. Sending the add request first followed by the change req does not calculate discounts in
                           the cart because the discount code dummy product is removed right after the add request. */
                        $.post(settings).then(function(){
                            self.addDcDummyProduct(function(){
                                self.updateCart();
                                self.setAppliedDc(self.discountCode);
                            });
                        });

                    } else if (type === self.CART_UPDATE) {

                        // stop request
                        jqxhr.abort();

                        $.post(settings).then(function(){
                            // cart update not required here
                            self.addDcDummyProduct(false);
                        });
                    }
                }
            });

            /**
             * Not an actual event but a mock structure for browser's fetch().
             * Used to detect when langify sends a cart/update.js request to set the current language, in this case
             * we need to add our discount code dummy again
             */
            var origFetch = window.fetch;
            window.fetch = async function(...args) {
                var response = await origFetch(...args);

                // detect if this is a langify language request by checking request parameters
                if (args[0] && args[1] && args[1].body && args[0].indexOf('cart/update.js') >= 0) {
                    var bodyJson = JSON.parse(args[1].body);
                    if (bodyJson.attributes && bodyJson.attributes.language) {
                        self.addDcDummyProduct();
                    }
                }

                return response;
            };

            // delete/update buttons on the cart page
            $('body').on('cartPageLoaded', function(){
                self.onCartPage = true;

                if (!self.getDisabledDcPreview()) {

                    // the 'delete' buttons
                    /*
                    $('.cart__row .cart_delete').each(function(key){
                        $(this).on('click', function(e){
                            if (e.target.href && e.target.href != '') {
                                $(this).addClass('btn--loading white');

                                e.preventDefault();

                                $.ajax(e.target.href).then(function(){
                                    self.addDcDummyProduct(function(){
                                        self.setAppliedDc(self.discountCode);
                                        // after product was added, follow the original link from the stopped event
                                        location.reload();
                                    });
                                });
                            }
                        });
                    });
                    */

                    // the 'cart update' button
                    $('form.cart button[name=update]').on('click', function(e){
                        $(this).addClass('btn--loading no-text-indent');

                        e.preventDefault();

                        $.ajax('/cart', {
                            type: 'POST',
                            data: $('form.cart').serialize()
                        }).then(function(){
                            if (self.getDiscountCode()) {
                                self.addDcDummyProduct(function() {
                                    self.setAppliedDc(self.discountCode);
                                    location.reload();
                                });
                            } else {
                                location.reload();
                            }
                        })
                    });

                    self.appendDcToForm();
                }
            });

            // on ajax cart load finish and update, check if new discount code needs to be applied
            // is also triggered on page load and empty cart
            $('body').on('updateCart.ajaxcart', function(event, cart){
                self.cart = cart;

                // auto-apply discount code
                if (self.getDiscountCode() && !self.dcApplied() && !self.getDisabledDcPreview()) {
                    self.dcButton.click();
                }

                self.removeDcProduct();
                self.updateSavedCart();
            });

            // set cookie to re-apply discount codes after language switch
            /*
            $('.ly-custom-dropdown-list-element.ly-languages-switcher-link:not(.current_lang)').click(function(){
                if (self.getDiscountCode()) {
                    Cookies.set('reapply_dc', 1);
                }
            });
            */

            // update cart when free gift products were added
            $('body').on('freegifts.added', function(){
                self.updateCart();
            });

            // update cart when free gift products were added
            $('body').on('freegifts.removed', function(){
                self.updateCart();
            });
        },

        // remove discount code dummy product if it wasnt removed from line-items script and is in the cart still
        removeDcProduct: function(){
            var self = this,
                updates = {updates:{}}; // data for /update request

            // determine if discount code dummy product is in cart
            $.each(self.cart.items, function(i, item) {
                if (item.variant_id == self.dummyVariantId) {
                    // hide discount code dummy product (remove from HTML)
                    $('div.ajaxcart__product[data-variant-id=' + self.dummyVariantId + ']').remove(); // product in cart drawer
                    $('form.cart .cart__row[data-variant-id=' + self.dummyVariantId + ']').remove();  // product on cart page

                    // remove product from cart
                    updates['updates'][self.dummyVariantId] = 0;

                    $.post({
                        url: '/cart/update.js',
                        data: updates,
                        dataType: 'json',
                        modified: true
                    });

                    // disable discount code preview for this session by setting a session-cookie
                    self.disableDcPreview();
                    self.showDcPreviewError();

                    return false; // abort loop
                }
            });
        },
    };

    discountCodeManager.init();

    // VKF/VSKF - Versandkostenfreiheit - free shipping progress bar
    var freeShippingProgressBar = {
        shopSettings: esn.getShopSettings(),
        freeShipSettings: null,
        cartTotal: null,
        country: null,
        realCountry: null,
        progressBarHidden: false,
        geoLocApiKey: '47c74d68bf55424ba8e577196a960d9c',

        startup: function() {
            this.country = this.getCountry();
            this.init();

            /*
            if (this.country) {
                this.init();
            } else {
                this.geoLocLookup(function(){
                    self.init();
                });
            }
            */
        },

        init: function(){
            this.parseFreeShippingSettings();
            if (!this.country) {
                this.country = this.getCountry();
            }

            // if no settings exist for the given country, use configured fallback
            if (!this.shopSettings.free_shipping_settings.active || (!this.freeShipSettings[this.country] && this.shopSettings.free_shipping_settings.default_fallback == 'HIDE')) {
                this.hideFreeShippingProgressBar();
                return;
            } else if ((!this.freeShipSettings[this.country] || !this.freeShipSettings[this.country].price) && this.shopSettings.free_shipping_settings.default_fallback == 'SONSTIGE') {
                this.realCountry = this.country;
                this.country = 'SONSTIGE';
            }

            let cart = discountCodeManager.getCart();
            if (cart && cart.items_subtotal_price) {
                this.cartTotal = cart.items_subtotal_price / 100;
            } else {
                this.cartTotal = 0;
            }

            this.setCurrentValues();
        },

        getDiscountCode: function(){
            return esn.getCookie("discount_code");
        },

        // set 'free_shipping_country' cookie that expires after 7 days
        setCountry: function(country){
            Cookies.set('free_shipping_country', country, {expires: 7});
        },

        getCountry: function(){
            //return Cookies.get('free_shipping_country');
            return this.shopSettings.country.toUpperCase();
        },

        // hide entire progress bar if feature is disabled
        hideFreeShippingProgressBar: function(){
            var htmlEle = $('.vkf-bar-cart-wrapper');

            if (htmlEle) {
                htmlEle.hide();
            }

            this.progressBarHidden = true;
        },

        showFreeShippingProgressBar: function(){
            var htmlEle = $('.vkf-bar-cart-wrapper');

            if (htmlEle) {
                htmlEle.show();
            }

            this.progressBarHidden = false;
        },

        // lookup info about user's geolocation via the API at https://api.ipgeolocation.io/ipgeo
        /*
        geoLocLookup: function(callback){
            var self = this;

            $.ajax('https://api.ipgeolocation.io/ipgeo?apiKey=' + this.geoLocApiKey).then(function(resp){
                if (resp && resp.country_code2) {
                    self.setCountry(resp.country_code2);

                    if (callback) {
                        callback();
                    }
                }
            });
        },
        */

        parseFreeShippingSettings: function(){
            var data = [];

            if (this.freeShipSettings) return;

            $(this.shopSettings.free_shipping_settings.shipping_groups).each(function(i, dataSet){
                if (!data[dataSet.country]) {
                    data[dataSet.country] = [];
                }

                if (dataSet.price) {
                    data[dataSet.country]['price'] = dataSet.price;
                    data[dataSet.country]['threshold'] = dataSet.free_shipping_threshold;
                } else {
                    if (!data[dataSet.country]['discount_codes']) {
                        data[dataSet.country]['discount_codes'] = [];
                    }
                    var len = data[dataSet.country]['discount_codes'].length;
                    if (!data[dataSet.country]['discount_codes'][len]) {
                        data[dataSet.country]['discount_codes'][len] = [];
                    }

                    if (dataSet.icodes) {
                        data[dataSet.country]['discount_codes'][len]['icodes'] = 1;
                    } else {
                        data[dataSet.country]['discount_codes'][len]['codes'] = dataSet.discount_codes.split('|');
                    }
                    data[dataSet.country]['discount_codes'][len]['threshold'] = dataSet.free_shipping_threshold;
                }
            });

            this.freeShipSettings = data;
        },

        getActiveThreshold: function(){
            var dc = this.getDiscountCode(),
                ret = parseFloat(this.freeShipSettings[this.country].threshold);

            if (!dc) return ret;

            //var country = (this.realCountry ? this.realCountry : this.country);

            for(key in this.freeShipSettings) {
                if (key == this.country) {
                    var countrySettings = this.freeShipSettings[key];
                    if (countrySettings.discount_codes) {
                        for (i in countrySettings.discount_codes) {
                            var codesSettings = countrySettings.discount_codes[i];
                            if (codesSettings.codes) {
                                // regular discount codes as configured in ACF
                                if ($.inArray(dc, codesSettings.codes) >= 0) {
                                    return codesSettings.threshold;
                                }
                            } else if (codesSettings.icodes) {
                                // influencer codes
                                if ($.inArray(dc, this.shopSettings.isettings.icodes) >= 0) {
                                    return codesSettings.threshold;
                                }
                            }
                        }
                    }
                }
            }

            return ret;
        },

        setCurrentValues: function(){
            var progRemainingText = $('.vkf_remaining'),
                progRemainingBar = $('.vkf-progress-value'),
                threshold = this.getActiveThreshold();

            var currentlyRemaining = threshold - this.cartTotal;

            if (this.progressBarHidden) {
                this.showFreeShippingProgressBar();
            }

            // shipping fee text
            $('.vkf_price_reg span')[0].innerText = theme.Currency.formatMoney(this.freeShipSettings[this.country].price * 100, this.shopSettings.money_format);

            if (currentlyRemaining > 0) {
                progRemainingText[0].innerText = theme.Currency.formatMoney(currentlyRemaining * 100, this.shopSettings.money_format);
                progRemainingBar.width(((this.cartTotal / threshold) * 100) + '%');

                $('.vkf_kosten').fadeIn(500);
                $('.vkf_kosten_complete').fadeOut(500);
                $('.vkf_price_reg').removeClass('full');
                $('.vkf_price_new').width(0);
                setTimeout(function(){
                    $('.vkf_price_new').hide();
                    $('.vkf_price_reg').fadeIn(500);
                }, 350);
            } else {
                progRemainingText[0].innerText = theme.Currency.formatMoney(0, this.shopSettings.money_format);
                progRemainingBar.width('100%');

                $('.vkf_kosten').fadeOut(500);
                $('.vkf_kosten_complete').fadeIn(500);
                $('.vkf_price_reg').addClass('full');
                $('.vkf_price_new').show().width(42);
            }
        }
    };

    // free gifts modal and button in cart
    var freeGiftsManager = {
        shopSettings: null,
        handles: null,
        currentlyRemaining: null,
        eventPrefix: 'freegifts',
        modalWrapper: $('#freegifts-container'),
        modalForm: $('#freegift-modal-product-form'),
        cartWrapper: $('.freegift-cart-wrapper'),
        button: $('#FreeGiftButton'),
        progressWrapper: $('.freegift-progress-wrapper'),
        inCartClass: 'in-cart',
        allInCartClass: 'all-in-cart',
        progressVisible: false,
        validCodes: [],
        origProductImg: [],
        allFreegiftsInCart: false,
        MODAL_PREVIEW: 1,
        MODAL_READY: 2,
        MODAL_IN_CART: 3,
        ENABLE: 1,
        DISABLE: 2,

        init: function(){
            this.shopSettings = esn.getShopSettings();
            this.getValidCodes();
            this.handles = esn.getShopSettings().free_products_check.handle;
            this.setEventHandlers();
        },

        getDiscountCode: function(){
            return esn.getCookie("discount_code");
        },

        validateCode: function(code){
            return code ? ($.inArray(code, this.validCodes) >= 0) : false;
        },

        getValidCodes: function(){
            if (this.shopSettings.free_products_check.discount_codes) {
                this.validCodes = this.shopSettings.free_products_check.discount_codes.split('|').concat(this.shopSettings.isettings.icodes);
            } else {
                this.validCodes = this.shopSettings.isettings.icodes;
            }
        },

        showAll: function(){
            this.cartWrapper.removeClass('hide');
            if (!this.progressVisible && (this.currentlyRemaining == null || this.currentlyRemaining > 0)) {
                this.progressUnhide();
                this.progressVisible = true;
            }
        },

        // hides all elements in the cart drawer
        hideAll: function(){
            this.cartWrapper.removeClass(this.allInCartClass);
            this.progressWrapper.addClass('hide');
            this.cartWrapper.addClass('hide');
            this.progressVisible = false;
        },

        modalOpen: function(){
            var self = this;

            this.modalWrapper.removeClass("hide");

            modalEscClose = function(e){
                $('body').off('keyup', modalEscClose);
                // timeout necessary so that the cart drawer doesnt also close
                setTimeout(function(){
                    if (e.keyCode == 27) {
                        self.modalClose();
                    }
                }, 10);
            };

            $('body').on('keyup', modalEscClose);

            this.preSelectVariants();
        },

        modalClose: function(){
            this.modalWrapper.addClass("hide");
        },

        preSelectVariants: function() {
            let preselectedVariants = [1,2,3],
                rows = $('.freegift-modal-product-row:not(.in-cart)');

            if (rows.length) {
                preselectedVariants.forEach((variantIndex, index) => {
                    let row = rows[index];

                    if (row) {
                        let options = $(row).find('.freegift-modal-variant-select option'),
                            defaultOption = options.filter('option[selected]')[0],
                            preselectedOption = options[variantIndex - 1];

                        if (preselectedOption && !preselectedOption.disabled) {
                            defaultOption.selected = false;
                            defaultOption.setAttribute('data-default', 'false');

                            preselectedOption.selected = true;
                            preselectedOption.setAttribute('data-default', 'true');
                        }
                    }
                });
            }
        },

        getActiveThreshold: function(){
            let ts = Shopify.currency.active == 'CHF' ? this.shopSettings.free_products_check.threshold_chf : this.shopSettings.free_products_check.threshold
            return parseFloat(ts) / 100;
        },

        progressUnhide: function(){
            var self = this;

            this.progressWrapper.removeClass('hide');
            this.progressWrapper.addClass('fadeIn');

            setTimeout(function(){
                self.progressWrapper.removeClass('fadeIn');
            }, 500);
        },

        progressSetCurrentValues: function(){
            let progRemainingText = $('.freegift-progress-remaining'),
                progRemainingBar = $('.freegift-progress-value'),
                threshold = this.getActiveThreshold();

            let cart = discountCodeManager.getCart(),
                cartTotal;
            if (cart && cart.items_subtotal_price) {
                cartTotal = cart.items_subtotal_price / 100;
            } else {
                cartTotal = 0;
            }

            this.currentlyRemaining = threshold - cartTotal;

            if (this.currentlyRemaining > 0) {
                progRemainingText[0].innerText = theme.Currency.formatMoney(this.currentlyRemaining * 100, this.shopSettings.money_format);
                progRemainingBar.width(((cartTotal / threshold) * 100) + '%');
            } else {
                progRemainingText[0].innerText = theme.Currency.formatMoney(0, this.shopSettings.money_format);
                progRemainingBar.width('100%');
            }
        },

        setEventHandlers: function(){
            var self = this;

            this.cartWrapper.on('click', function(){
                self.modalOpen();
            });

            $('body').on('discount_code.remove_button_hidden', function(){
                if (!self.shopSettings.free_products_check.disc_cd_not_required) {
                    self.hideAll();
                }
            });

            $(window).on('discount_code.changed', function(){
                if (!self.shopSettings.free_products_check.disc_cd_not_required) {
                    if (self.validateCode(self.getDiscountCode())) {
                        self.showAll();
                    }
                    else {
                        self.hideAll();
                    }
                }
            });

            $(".freegift-modal-close").on("click", function(){
                self.modalClose();
            });

            $('.freegift-modal-background').on('click', function(){
                self.modalClose();
            });

            $('body').on('discount_code.disabled', function(){
                self.cartWrapper.remove();
            });

            // update radio button value (if any) and change product image on variant change
            $('.freegift-modal-variant-select').on('change', function(){
                var self = this;

                let radio = $(this).parents('.freegift-modal-product-row').find('input[type="radio"]').first();
                if (radio && radio.length) {
                    radio.val(this.value);
                }

                var img = $(this).parents('.freegift-modal-product-group').find('img');
                img.addClass('flipOutX');

                setTimeout(function(){
                    img.attr('src', self.selectedOptions[0].getAttribute('data-image'));
                }, 250);

                img.on('load', function () {
                    img.removeClass('flipOutX');
                    img.addClass('flipInX');

                    setTimeout(function () {
                        img.removeClass('flipInX');
                    }, 350);
                });
            });

            this.modalForm.submit(function(e){
                e.preventDefault();

                var data = queryToObj(self.modalForm.serialize()),
                    items = [],
                    keysDone = [];

                if (data.items) {
                    $('#freegift-modal-submit').addClass('btn--loading');

                    // process form data and combine multiple occurrences of the same item into one
                    var itemKeys = Object.keys(data.items);
                    $(itemKeys).each(function(i, keyPrimary){
                        var quant = parseInt(data.items[keyPrimary].quantity);

                        if ($.inArray(keyPrimary, keysDone) < 0) { // skip already processed rows
                            $(itemKeys).each(function (j, keySecondary) {
                                if (i != j && $.inArray(keySecondary, keysDone) < 0) {
                                    if (data.items[keyPrimary].id == data.items[keySecondary].id) {
                                        quant += parseInt(data.items[keySecondary].quantity);
                                        keysDone.push(keyPrimary, keySecondary);
                                    }
                                }
                            });

                            items.push({id: data.items[keyPrimary].id, quantity: quant});
                        }
                    });

                    $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: {items},
                        dataType: "json",
                        complete: function () {
                            $('body').trigger(self.eventPrefix + '.added');

                            $('#freegift-modal-submit').removeClass('btn--loading');

                            // show "success overlay"
                            $('.freegift-modal-success-overlay').removeClass('hide');
                            $('.freegift-modal-success-mark').addClass('bounceInDown');

                            // close modal
                            setTimeout(function () {
                                self.modalClose();
                                $('.freegift-modal-success-mark').removeClass('bounceInDown');
                                $('.freegift-modal-success-overlay').addClass('hide');
                            }, 2000)
                        }
                    });
                }
            });

            // modify modal content based on user's current cart, on each cart update
            $('body').on('updateCart.ajaxcart', function(event, cart) {
                if (!self.shopSettings.free_products_check.disc_cd_not_required && !self.validateCode(self.getDiscountCode())) {
                    if (self.progressVisible) {
                        self.hideAll();
                    }

                    return;
                }

                self.progressSetCurrentValues();

                if (self.currentlyRemaining > 0) {
                    // disable all previously enabled elements
                    self.toggleStateIndividualProducts(self.DISABLE);
                    self.toggleStateProductSelections(self.DISABLE);
                }

                // reset any "in-cart" classes
                $('.' + self.inCartClass).each(function(){
                    $(this).removeClass(self.inCartClass);
                });

                // select default options
                var defaultOptions = $('.freegift-modal-product-row option[data-default="true"]');
                defaultOptions.each(function(){
                    this.selected = true;

                    // reset variant image
                    $(this).parents('.freegift-modal-product-group').find('img').attr('src', this.getAttribute('data-image'));
                });
                // select default radio buttons
                var defaultRadios = $('.freegift-modal-product-selection input[data-default="true"]');
                defaultRadios.each(function(){
                    this.checked = true;
                });

                // gather all freegift products from user's cart
                if (self.currentlyRemaining != null && self.currentlyRemaining <= 0) {
                    var items = [];
                    var foundHandles = [];
                    $(self.handles).each(function (i, handles) {
                        var handlesArray = handles.split("|");

                        $(handlesArray).each(function (j, handle) {
                            // get product id by handle from cart items
                            $(cart.items).each(function (l, item) {
                                // only consider free products
                                if (item.discounted_price == 0 && item.handle == handle) {
                                    $(item.discounts).each(function(){
                                        var title = this.title.toLowerCase();
                                        if (title.indexOf('gratis ab') >= 0 || title.indexOf('free over') >= 0 || title.indexOf('gratis desde') >= 0
                                            || title.indexOf('gratuite dès') >= 0 || title.indexOf('gratis van') >= 0 || title.indexOf('gratuito da') >= 0) {
                                            items.push({id: item.id, quantity: item.quantity});
                                            foundHandles[handles] = foundHandles[handles] ? foundHandles[handles] + item.quantity : item.quantity;
                                            return false;
                                        }
                                    });
                                    // Synergy-Hack
                                    if (item.discounts.length == 0 && item.price == 0 && item.line_price == 0) {
                                        items.push({id: item.id, quantity: item.quantity});
                                        foundHandles[handles] = foundHandles[handles] ? foundHandles[handles] + item.quantity : item.quantity;
                                        return false;
                                    }
                                }
                            });
                        });
                    });

                    // check if user's cart contains all freegift products
                    self.allFreegiftsInCart = false;
                    if (Object.keys(foundHandles).length == self.handles.length) {
                        // check quantity
                        var configuredQuantity = esn.getShopSettings().free_products_check.quant;
                        self.allFreegiftsInCart = true;

                        for(var i = 0; i < self.handles.length; i++) {
                            if (foundHandles[self.handles[i]] < parseInt(configuredQuantity[i])) {
                                self.allFreegiftsInCart = false;
                            }
                        }
                    }

                    if (self.allFreegiftsInCart) {
                        // change modal heading to "in-cart mode"
                        self.changeModalHeading(self.MODAL_IN_CART);
                    } else {
                        self.progressWrapper.fadeOut(500);
                        setTimeout(function(){
                            self.button.fadeIn(500);
                        }, 500);

                        // change modal heading to "ready mode"
                        self.changeModalHeading(self.MODAL_READY);
                    }

                    // determine what products are in the user's cart and set the "in-cart" class accordingly
                    if (items.length) {
                        var individualProducts = [],
                            productSelections = [];

                        $(items).each(function(j, item){
                            // select the variant of the freegift product that is already in the cart
                            var inputs = $('.freegift-modal-product-row:not(.' + self.inCartClass + ') select[name] option[value="'+item.id+'"], .freegift-modal-product-row:not(.' + self.inCartClass + ') input[value="'+item.id+'"][type!="radio"]');
                            if (inputs.length) {
                                for(var i = 0; i < item.quantity; i++) {
                                    if (inputs[i]) {
                                        inputs[i].selected = true;

                                        var productRow = $(inputs[i]).parents('.freegift-modal-product-row');
                                        productRow.addClass(self.inCartClass);

                                        // set variant image as main image
                                        if (inputs[i].nodeName == 'OPTION') {
                                            $(inputs[i]).parents('.freegift-modal-product-group').find('img').attr('src', inputs[i].getAttribute('data-image'));
                                        }

                                        individualProducts.push(productRow[0]);
                                    }
                                }
                            }

                            // select the radio button of the freegift product that is already in the cart
                            var inCartProductInputs = $('.freegift-modal-product-selection:not(.' + self.inCartClass + ') [value="'+item.id+'"]');
                            if (inCartProductInputs.length) {
                                let nodeName = inCartProductInputs[0].nodeName,
                                    actionsPerformed = 0;

                                inCartProductInputs.each(function(j, input){
                                    if (input.nodeName == nodeName && actionsPerformed < item.quantity) {
                                        let parentRow = $(input).parents('.freegift-modal-product-row');

                                        if (input.nodeName == 'RADIO') {
                                            input.checked = true;
                                        } else {
                                            input.selected = true;

                                            let radio = parentRow.find('input[type=radio]');
                                            radio[0].checked = true;
                                        }

                                        var productSelection = parentRow.parents('.freegift-modal-product-selection');
                                        productSelection.addClass(self.inCartClass);
                                        parentRow.addClass(self.inCartClass);

                                        productSelections.push(productSelection[0]);

                                        actionsPerformed++;
                                        if (actionsPerformed >= item.quantity) {
                                            return false;
                                        }
                                    }
                                });
                            }
                        });
                    }

                    // disable all modal elements that do have the class "in-cart"
                    self.toggleStateIndividualProducts(self.DISABLE, $(individualProducts));
                    self.toggleStateProductSelections(self.DISABLE, $(productSelections));

                    // enable all disabled modal elements that do not have the class "in-cart"
                    self.toggleStateIndividualProducts(self.ENABLE);
                    self.toggleStateProductSelections(self.ENABLE);

                    self.progressWrapper.fadeOut(500);
                    setTimeout(function() {
                        self.button.fadeIn(500);
                        if (self.allFreegiftsInCart) {
                            self.cartWrapper.addClass(self.allInCartClass);
                        }
                    }, 500);

                    // enable or disable "add to cart" button in modal
                    var enabledProducts = $('.freegift-modal-product-row:not(.disabled)');
                    if (enabledProducts.length) {
                        $('#freegift-modal-submit').prop('disabled', false);
                    } else {
                        $('#freegift-modal-submit').prop('disabled', true);
                    }
                } else {
                    self.button.fadeOut(500);
                    setTimeout(function () {
                        self.progressWrapper.fadeIn(500);
                    }, 500);

                    self.cartWrapper.removeClass(self.allInCartClass);

                    // change modal heading to "preview mode"
                    self.changeModalHeading(self.MODAL_PREVIEW);

                    // disable "add to cart" button in modal
                    $('#freegift-modal-submit').prop('disabled', true);
                }

                // hide/show labels above products in modal
                var freegiftBlocks = $('.freegift-modal-product-individual, .freegift-modal-product-selection');
                freegiftBlocks.each(function(){
                    var label;

                    if ($(this).hasClass('freegift-modal-product-selection')) {
                        label = '>span';
                        if ($(this).hasClass(self.inCartClass)) {
                            $(this).find(label).css('opacity', 0);
                        } else {
                            $(this).find(label).css('opacity', '');
                        }
                    } else {
                        label = '>p';
                        if (!$(this).find('.freegift-modal-product-row:not(.' + self.inCartClass + ')').length) {
                            $(this).find(label).addClass('hide');
                        } else {
                            $(this).find(label).removeClass('hide');
                        }
                    }
                });

                // show/hide cart button

                setTimeout(function(){
                    self.showAll();
                }, 500)

                if (!self.allFreegiftsInCart) {
                    self.cartWrapper.removeClass(self.allInCartClass);
                }
            });
        },

        changeModalHeading: function(state){
            if (!state) return;

            var modalHeadings = $('.freegift-modal-body-heading-content >span'),
                classes = [];
            classes[1] = 'preview';
            classes[2] = 'ready';
            classes[3] = 'already-in-cart';

            modalHeadings.each(function(i, span) {
                if ($(span).hasClass(classes[state])) {
                    $(span).removeClass('hide');
                } else {
                    $(span).addClass('hide');
                }
            });
        },

        /**
         * does 2 things:
         * - enables all disabled individual product rows that do not have the class "in-cart"
         * - disables all previously enabled individual product rows
         *
         * @param {int} state         this.ENABLE (1) = enables elements, this.DISABLE (2) = disable elements
         * @param {array} productRows Array with jQuery objects of ".freegift-modal-product-individual .freegift-modal-product-row"
         *                            elements. Pass this parameter to use a custom set of elements to work through.
         */
        toggleStateIndividualProducts: function(state, productRows = null){
            var self = this;

            if (!productRows) {
                if (state == this.ENABLE) {
                    productRows = $('.freegift-modal-product-individual .freegift-modal-product-row.disabled:not(.' + this.inCartClass + ')');
                } else {
                    productRows = $('.freegift-modal-product-individual .freegift-modal-product-row:not(.disabled)');
                }
            }

            if (productRows.length) {
                productRows.each(function() {
                    if (state == self.ENABLE) {
                        $(this).removeClass('disabled');
                    }
                    else {
                        $(this).addClass('disabled');
                    }

                    var inputs = $(this).find('select, input');
                    inputs.each(function(i, ele){
                        ele.disabled = (state == self.ENABLE) ? false : true;
                    });
                });
            }
        },

        /**
         * does 2 things:
         * - enables all disabled product selections (defined by radio groups) that do not have the class "in-cart"
         * - disables all previously enabled product selections
         *
         * @param {int} state               this.ENABLE (1) = enables elements, this.DISABLE (2) = disable elements
         * @param {array} productSelections Array with jQuery objects of ".freegift-modal-product-selection" elements.
         *                                  Pass this parameter to use a custom set of elements to work through.
         */
        toggleStateProductSelections: function(state, productSelections = null){
            var self = this;

            if (!productSelections) {
                if (state == this.ENABLE) {
                    productSelections = $('.freegift-modal-product-selection.disabled:not(.' + this.inCartClass + ')');
                } else {
                    productSelections = $('.freegift-modal-product-selection:not(.disabled)');
                }
            }

            if (productSelections.length) {
                productSelections.each(function () {
                    if (state == self.ENABLE) {
                        $(this).removeClass('disabled');
                    }
                    else {
                        $(this).addClass('disabled');
                    }

                    var productRows = $(this).find('.freegift-modal-product-row:not(:has(.freegift-modal-title span.freegift-modal-alert))'),
                        checkedFirst = false;
                    productRows.each(function () {
                        if (state == self.ENABLE) {
                            $(this).removeClass('disabled');
                        }
                        else {
                            $(this).addClass('disabled');
                        }

                        var radioButton = $(this).find('input[type="radio"]');
                        if (radioButton.length) {
                            if (state == self.ENABLE) {
                                radioButton[0].disabled = false;
                                if (!checkedFirst) {
                                    radioButton[0].checked = true;
                                    checkedFirst = true;
                                }
                            } else {
                                radioButton[0].disabled = true;
                            }
                        }

                        var select = $(this).find('select');
                        if (select.length) {
                            select[0].disabled = (state == self.ENABLE) ? false : true;
                        }
                    });

                    var quantInput = $(this).find('.input-quantity');
                    if (quantInput.length) {
                        quantInput[0].disabled = (state == self.ENABLE) ? false : true;
                    }
                });
            }
        },
    };

    var autoGiftManager = {
        shopSettings: null,
        giftId: null,
        currentlyRemaining: null,
        buttonAnimationInterval: null,
        eventPrefix: 'freegifts',
        form: $('#autogift-product-form'),
        cartWrapper: $('[data-autogift-cart-wrapper]'),
        buttonWrapper: $('[data-autogift-button-wrapper]'),
        button: $('[data-autogift-button]'),
        progressWrapper: $('[data-autogift-progress-wrapper]'),
        inCartClass: 'in-cart',
        buttonVisible: false,
        allInCartClass: 'all-in-cart',
        progressVisible: false,
        validCodes: [],
        allAutogiftsInCart: false,

        init: function(){
            this.shopSettings = esn.getShopSettings();
            this.getValidCodes();
            this.giftId = esn.getShopSettings().auto_product_check.giftId;
            this.setEventHandlers();

            if (this.shopSettings.auto_product_check.disc_cd_not_required || this.validateCode(this.getDiscountCode())) {
                this.showAll();
            }
        },

        getDiscountCode: function(){
            return esn.getCookie("discount_code");
        },

        validateCode: function(code){
            return code ? ($.inArray(code, this.validCodes) >= 0) : false;
        },

        getValidCodes: function(){
            if (this.shopSettings.auto_product_check.discount_codes) {
                this.validCodes = this.shopSettings.auto_product_check.discount_codes.split('|').concat(this.shopSettings.isettings.icodes);
            } else {
                this.validCodes = this.shopSettings.isettings.icodes;
            }
        },

       showAll: function(){
            var self = this;

            if (this.buttonShow()) {
                setTimeout(function() {
                    self.progressUnhide();
                }, 1700);
            } else {
                if (self.currentlyRemaining != null && self.currentlyRemaining <= 0 && self.allAutogiftsInCart) {
                    self.cartWrapper.addClass('all-in-cart');
                    clearInterval(self.buttonAnimationInterval);
                }
            }

            self.progressSetCurrentValues();
        },

        // hides all elements in the ajax cart drawer
        hideAll: function(){
            clearInterval(this.buttonAnimationInterval);
            this.button.css('visibility', 'hidden');
            this.button.height(0);
            this.button.removeClass('animation-done');
            this.cartWrapper.removeClass('all-in-cart');
            this.progressWrapper.addClass('hide');
            this.cartWrapper.addClass('hide');
            this.buttonVisible = false;
            this.allAutogiftsInCart = false;
        },

        setButtonAnimationInterval: function(interval = 6000){
            if (this.buttonVisible) {
                var self = this;

                if (this.buttonAnimationInterval) {
                    clearInterval(this.buttonAnimationInterval);
                }
                this.buttonAnimationInterval = setInterval(function() {
                    self.buttonAnimate();
                }, interval);
            }
        },

        buttonAnimate: function(){
            if (theme.cartDrawer.drawer.isOpen) {
                var self = this;

                setAnimationClass = function(){
                    self.button.addClass('tada');
                    setTimeout(function() {
                        self.button.removeClass('tada');
                    }, 1000);
                };

                if (this.button.hasClass('animation-done')) {
                    setAnimationClass();
                } else {
                    $('body').on('freegifts.cart_button_animation_done', function(){
                        $('body').off('freegifts.cart_button_animation_done');
                        setAnimationClass();
                    });
                }
            }
        },

        // returns true if button was unhidden, false otherwise
        buttonShow: function(){
            if (!this.buttonVisible) {
                if (theme.cartDrawer.drawer.isOpen) {
                    this.buttonUnhideAnimated();
                } else {
                    this.buttonUnhide();
                }

                return true;
            }

            return false;
        },

        buttonUnhide: function(){
            this.cartWrapper.removeClass('hide');
            this.button.height(48);
            this.button.css('visibility', 'unset');
            this.button.addClass('animation-done');
            this.buttonVisible = true;
        },

        // show button using a sliding animation from top
        buttonUnhideAnimated: function(){
            var self = this;

            this.cartWrapper.removeClass('hide');
            this.button.height(48);
            this.button.addClass('bounceInDown_mild');
            this.button.css('visibility', 'unset');
            this.buttonVisible = true;
            setTimeout(function() {
                self.button.removeClass('bounceInDown_mild');
                self.button.addClass('animation-done');
                if (self.allAutogiftsInCart) {
                    setTimeout(function(){
                        self.cartWrapper.addClass('all-in-cart');
                        clearInterval(self.buttonAnimationInterval);
                    }, 550);
                }
                setTimeout(function(){
                    $('body').trigger(self.eventPrefix + '.cart_button_animation_done');
                }, 550);
            }, 1100);
        },

        getActiveThreshold: function(){
            let ts = Shopify.currency.active == 'CHF' ? this.shopSettings.auto_product_check.threshold_chf : this.shopSettings.auto_product_check.threshold
            return parseFloat(ts) / 100;
        },

        progressUnhide: function(){
            var self = this;

            this.progressWrapper.removeClass('hide');
            this.progressWrapper.addClass('fadeIn');

            setTimeout(function(){
                self.progressWrapper.removeClass('fadeIn');
            }, 500);
        },

        progressSetCurrentValues: function(){
            var progRemainingText = $('[data-autogift-progress-remaining]'),
                progRemainingBar = $('[data-autogift-progress-value]'),
                threshold = this.getActiveThreshold();

            let cart = discountCodeManager.getCart(),
                cartTotal;
            if (cart && cart.items_subtotal_price) {
                cartTotal = cart.items_subtotal_price / 100;
            } else {
                cartTotal = 0;
            }

            this.currentlyRemaining = threshold - cartTotal;

            if (this.currentlyRemaining > 0) {
                progRemainingText[0].innerText = theme.Currency.formatMoney(this.currentlyRemaining * 100, this.shopSettings.money_format);
                progRemainingBar.width(((cartTotal / threshold) * 100) + '%');
            } else {
                progRemainingText[0].innerText = theme.Currency.formatMoney(0, this.shopSettings.money_format);
                progRemainingBar.width('100%');
            }
        },

        setEventHandlers: function(){
            var self = this;

            $('body').on('discount_code.remove_button_hidden', function(){
                if (!self.shopSettings.auto_product_check.disc_cd_not_required) {
                    self.hideAll();
                }
            });
          
            $('body').on('drawerClose',function(){
                clearInterval(self.buttonAnimationInterval);
            });

            $('body').on('drawerOpen',function(){
                if (self.currentlyRemaining != null && self.currentlyRemaining <= 0 && !self.cartWrapper.hasClass('all-in-cart')) {
                    setTimeout(function(){
                        self.buttonAnimate();
                    }, 1000);
                }
            });

            $('body').on('discount_code.disabled', function(){
                self.cartWrapper.remove();
            });

            function addGiftToCart () {
                var data = self.form.serialize();

                if (self.validateCode(self.getDiscountCode()) || self.shopSettings.auto_product_check.disc_cd_not_required) {
                    $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: {data},
                        dataType: "json",
                        complete: function () {
                            $('body').trigger(self.eventPrefix + '.added');
                        }
                    });
                }
            }

            function removeGiftFromCart () {
                if (self.validateCode(self.getDiscountCode()) || self.shopSettings.auto_product_check.disc_cd_not_required) {
                    $.ajax({
                        type: "POST",
                        url: "/cart/change.js",
                        data: {
                            "id": self.giftId,
                            "quantity": 0
                        },
                        dataType: "json",
                        complete: function () {
                            $('body').trigger(self.eventPrefix + '.removed');
                        }
                    });
                }
            }


            // modify cart drawer content based on user's current cart, on each cart update
            $('body').on('updateCart.ajaxcart', function(event, cart) {
                if (!self.shopSettings.auto_product_check.disc_cd_not_required && !self.validateCode(self.getDiscountCode())) {
                    if (self.progressVisible) {
                        self.hideAll();
                    }
                    return;
                }

                var text = $('[data-autogift-text]'),
                    textComplete = $('[data-autogift-text-complete]'),
                    textAll = $('[data-autogift-text-all-in-cart]');

                self.progressSetCurrentValues();

                // reset any "in-cart" classes
                $('.' + self.inCartClass).each(function(){
                    $(this).removeClass(self.inCartClass);
                });

                self.allAutogiftsInCart = false;

              $(cart.items).each(function (l, item) {
                    // only consider free products
                    if (item.id == self.giftId) {
                        self.allAutogiftsInCart = true;
                    }
                });

                // gather all freegift products from user's cart
                if (self.currentlyRemaining != null && self.currentlyRemaining <= 0) {
                    if (self.allAutogiftsInCart) {
                        $(textComplete[1]).fadeOut(500);
                        setTimeout(function(){
                            textAll.fadeIn(500);
                        }, 500);
                    } else {
                        textAll.fadeOut(500);

                        addGiftToCart();

                        setTimeout(function(){
                            $(textComplete[1]).fadeIn(500);
                        }, 500);
                    }

                    // show correct texts for progress-bar
                    if (!self.progressWrapper.hasClass('complete')) {
                        text.fadeOut(500);

                        setTimeout(function () {
                            self.progressWrapper.addClass('complete');
                            if (self.allAutogiftsInCart) {
                                $(textComplete[0]).fadeIn(500);
                                textAll.fadeIn(500);
                            } else {
                                textComplete.fadeIn(500);
                            }
                        }, 500);
                    }
                } else {
                    if (self.progressWrapper.hasClass('complete')) {
                        textComplete.fadeOut(500);
                        textAll.fadeOut(500);

                        setTimeout(function () {
                            self.progressWrapper.removeClass('complete');
                            text.fadeIn(500);
                        }, 500);
                    }

                    if (self.allAutogiftsInCart) {
                        self.allAutogiftsInCart = false;

                        removeGiftFromCart();
                    }

                    clearInterval(self.buttonAnimationInterval);
                    self.buttonWrapper.removeClass('all-in-cart');
                    self.cartWrapper.removeClass('all-in-cart');
                }
                // show/hide cart button
                self.showAll();

                if (!self.allAutogiftsInCart) {
                    if (self.currentlyRemaining != null && self.currentlyRemaining <= 0) {
                        self.buttonAnimate();
                        self.setButtonAnimationInterval();
                    }
                    self.cartWrapper.removeClass('all-in-cart');
                }
            });

            $(window).on('discount_code.changed', function(){
                if (self.validateCode(self.getDiscountCode())) {
                    self.showAll();
                }
                else {
                    if (self.buttonVisible) {
                        self.hideAll();
                    }
                }
            });

            $(window).on('discount_code.changed', function(){
                if (!self.shopSettings.auto_product_check.disc_cd_not_required) {
                    if (self.validateCode(self.getDiscountCode())) {
                        self.showAll();
                    }
                    else {
                        if (self.buttonVisible) {
                            self.hideAll();
                        }
                    }
                }
            });
        },
    };

    if (esn.getShopSettings().free_products_check && esn.getShopSettings().free_products_check.handle && !Cookies.get('disable_discount_code_preview')) {
        freeGiftsManager.init();
    }

    if (esn.getShopSettings().auto_product_check && esn.getShopSettings().auto_product_check.variant_available && esn.getShopSettings().auto_product_check.giftId && !Cookies.get('disable_discount_code_preview')) {
        autoGiftManager.init();
    }

    $('body').on('updateCart.ajaxcart discount_code.finished_loading discount_code.remove_button_hidden', function(){
        freeShippingProgressBar.startup();
    });

    if (typeof meta !== 'undefined' && typeof meta.page !== "undefined" && typeof meta.page.pageType !== "undefined" && meta.page.pageType == 'cart') {
        $('body').trigger('cartPageLoaded');
    }

    showHiddenProducts();

    // Influencer Page - Banner switch tab buttons
    var heroImgTabButtons = $('.dgs-influencer-slides-navi-button');
    heroImgTabButtons.on('click', function(){
        var index = this.getAttribute('item-slide'),
            toggleActiveIndexes = [];

        // set 'active' class
        $(this).addClass('active');
        if (index == 0) {
            toggleActiveIndexes = [0, 1];
        } else {
            toggleActiveIndexes = [1, 0];
        }
        $(heroImgTabButtons[toggleActiveIndexes[0]]).addClass('active');
        $(heroImgTabButtons[toggleActiveIndexes[1]]).removeClass('active');

        // replace hero banner img
        var heroImg = $('.collection-hero__image');
        if (heroImg.length) {
            var newImg = heroImg[0].cloneNode();
            newImg.removeAttribute('srcset');
            newImg.removeAttribute('data-srcset');
            newImg.removeAttribute('sizes');
            $(newImg).removeClass('lazyautosizes lazyloaded');
            $(newImg).addClass('lazyload');
            newImg.setAttribute('data-src', this.getAttribute('item-hero'));
            heroImg[0].replaceWith(newImg);
        }

        // show corresponding content
        var contentContainer = $('#CollectionAjaxContent .grid div[item-slide]');
        $(contentContainer[toggleActiveIndexes[0]]).show();
        $(contentContainer[toggleActiveIndexes[1]]).hide();
    });

    // ----------------------------------------
    // SG, 11.05.2022 Moin.ai widget
    // ----------------------------------------
    (function() {
        var prodPage = false;

        function loadMoin() {
            $("body").append($("<script />", {
                type: "text/javascript",
                src: "https://widget.moin.ai/moin-loader.js?id=yh3fFuJN&channelid=yh3fFuJN",
                id: "moinloader" /*,
                async: true */
            }));
        }

        if (typeof meta !== "undefined" && typeof meta.product !== "undefined" && typeof meta.product.id !== "undefined" && meta.product.id > 0) {
            prodPage = true;
        }

        if (esn.getShopSettings().show_chatbot && (!prodPage || $(window).width() > 720) && esn.getShopSettings().lang == "de" && esn.getShopSettings().market == "domestic") {
            window.chatWidgetReady = function() {
                $('body').on('drawerClose', function() {
                    window.knowhere.api.showWidget();
                });
                $('body').on('drawerOpen', function() {
                    window.knowhere.api.hideWidget();
                });
                var path = esn.getShopSettings().request_path,
                    mess = "", txt = "", intent = "";
                if (path == false) {
                    return;
                } else if (path.startsWith("/pages/kontakt")) {
                    mess = "Brauchst Du Infos zu Deiner Bestellung?";
                    txt = "Schau hier: Bestellung";
                    intent = "faq_standard_bestelldetails";
                } else if (path.startsWith("/collections/proteinpulver")) {
                    mess = "Willst Du mehr Infos zu Proteinpulver?";
                    txt = "Klick hier: Proteinpulver";
                    intent = "faq_proteinpulver";
                } else if (path.startsWith("/collections/supplemente")) {
                    mess = "Willst Du mehr zu Kreatin wissen?";
                    txt = "Schau hier: Kreatin";
                    intent = "faq_kreatin";
                }
                if (mess != "" && text != "" && intent != "") {
                    window.knowhere.api.teaser({
                        showTeaser: true,
                        showAvatar: true,
                        message: mess,
                        quickActions: [{
                            text: txt,
                            intent: intent
                        }]
                    });
                    //window.knowhere.api.open();
                }
            }
            //setTimeout(loadMoin, 500);
            loadMoin();
        }
    })();

    // DEV-1298/DEV-1307 pass variant market metafield value to line-items script via line-item property
    $(document).ajaxSend(function(event, jqxhr, settings){
        if (settings.url.indexOf("cart/add") >= 0) {

            var dataObj = queryToObj(settings.data),
                data = {items:[]};

            // dataObj can contain one or multiple items (i. e. from discount code dummy, bundles)
            if (typeof dataObj.items === 'undefined') {
                dataObj.items = [];
                dataObj.items.push({id: dataObj.id, quantity: dataObj.quantity});
            }

            $.each(dataObj.items, function(i, item) {
                if (item) {
                    if (item.id != esn.getShopSettings().discount_code.dummy_id && (!item.properties || !item.properties._fbt)) {
                        // loop through all .variants-metafields-json elements to match the variant. usually there's only 1
                        // on the PDP, but there can be multiple, i. e. if freegifts are currently configured and active
                        $('.variants-metafields-json').each(function(j, variantMetafields) {
                            metafieldsJson = JSON.parse(variantMetafields.innerHTML);
                            // check if we found the correct .variants-metafields-json element
                            if (metafieldsJson[item.id]) {
                                if (!dataObj.items[i].properties) {
                                    dataObj.items[i].properties = {'_market': metafieldsJson[item.id].market};
                                }
                                else if (!dataObj.items[i].properties['_market']) {
                                    dataObj.items[i].properties['_market'] = metafieldsJson[item.id].market
                                }
                            }
                        });
                    }

                    data.items.push(item);
                }
            });

            settings.data = $.param(data);
        }
    });

    // ---------------------------------------
    // SG, 2022-06-01
    // Anchor Jumps on blog articles
    // AM: commented out because this functionality is included in our smooth scrolling snippet
    // ---------------------------------------
    /*
    if (typeof meta === "object" && typeof meta.page === "object" && typeof meta.page.pageType !== "undefined") {
        $("a.bb_anchors--link").each(function(){
            $(this).on('click', function(ev){
                var target = this.getAttribute("href");
                if (target.length > 0 && target.charAt(0) == "#" && $(target).length == 1) {
                    ev.preventDefault();
                    $(target)[0].scrollIntoView();
                    window.scrollBy(0, $("header").outerHeight() * -1);
                }
            });
        });
    }
    */

    // DEV-1294, FOOTER > NL-Modal
    /*
    var nlFooter = $('#newsletter-footer');
    if (nlFooter.length && nlFooter.find('#NLModal').length) {
        var nlModal = new theme.Modals('NLModal', 'nl-modal', {
            solid: true
        });
        nlModal.open();
    }
    */

    // DEV-1398, temp. "coming back soon" modal
    var backSoonModal = $('#BackSoonModal');
    if (backSoonModal.length) {
        var seen = Cookies.get('popup_seen');

        if (!seen) {
            var bsModal = new theme.Modals('BackSoonModal', 'back-soon-modal', {
                solid: true
            });
            bsModal.open();

            $('.modal-confirm').on('click', bsModal.close.bind(bsModal));

            // on modal close, memorize user's decision and dont show again for the rest of the session
            $('body').on('modalClose.BackSoonModal', function() {
                Cookies.set('popup_seen', 1);
            });

            /* not needed, handled through GTM:
            $(window).on("CookiebotOnConsentReady", function() {
                if (esn.getCookiebotConsent('marketing')) {
                    var script = document.createElement("script");
                    script.setAttribute('src', 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RXHQa6');
                    document.append(script);
                }
            });
            */
        }
    }

    // DEV-1340, Int customer popup
    initPopup();

    async function initPopup() {
        const shopSettings = JSON.parse($("#shop-settings").text());
        if (!shopSettings.available_countries || !shopSettings.geolocation_api_key) {
            return;
        }
        let showPopup = false;
        const popup = document.querySelector('.international-popup');
        const countries = shopSettings.available_countries;
        if (!sessionStorage.getItem('country_code')) {
            await fetch(`https://api.ipgeolocation.io/ipgeo?apiKey=${shopSettings.geolocation_api_key}`).then((response) => response.json()).then((data) => {
                sessionStorage.setItem('country_code', data.country_code2.toLowerCase())
                if (!countries.includes(data.country_code2.toLowerCase())) {
                    sessionStorage.getItem("closedInternationalPopup") ? showPopup = false : showPopup = true;
                }
                popup.setAttribute('show-popup', showPopup)
            })
        }else{
            if (!countries.includes(sessionStorage.getItem('country_code'))) {
                sessionStorage.getItem("closedInternationalPopup") ? showPopup = false : showPopup = true;
            }
            popup.setAttribute('show-popup', showPopup)
        }
    }

    $('.international-popup__cross-button, .international-popup__close-button, .international-popup__overlay').on('click', () => {
        const popup = document.querySelector('.international-popup');
        showPopup = false;
        sessionStorage.setItem("closedInternationalPopup", true);
        popup.setAttribute('show-popup', showPopup);
    });

    // DEV-1474, Klaviyo Submit
    window.addEventListener("klaviyoForms", function (e) {
        if (e.detail.type == 'submit') {
            klaviyo.track('Submitted Form', e.detail);
        }
    });

    // DEV-1439 CK, addToCartEvents dataLayer, GTM
    // DEV-1494 CK, addToCart, Klaviyo

    $('body').on('added.ajaxProduct', function(event, element, product) {

      window._learnq = window._learnq || [];
      window.dataLayer = window.dataLayer || [];
      let products = [];

      if (product && product.items) {
        let j = 0;
        for (itm of product.items) {
          // only for not-dummie-products
          if (itm.handle !== "rabatt-code") {
            let q = 1;
            // identify quantity for products or bundles
            if (element && element.hasClass("add-to-cart")) {
              let qtyInput = document.querySelector("input#Quantity-" + itm.product_id);
              if (qtyInput) {
                q = qtyInput.value;
              }
              if (meta.product.type == "bundle") {
                let qtyInput = document.querySelector("input#Quantity-" + meta.product.id);
                if (qtyInput) {
                  q = qtyInput.value;
                }
              }
            }

            // write fbt or bundles object in an array for klaviyo
            if (element && element.hasClass("fbt_form_button") || element && element.hasClass("add-to-cart") && meta.product.type === "bundle") {
              let klavProduct = {};
              klavProduct = {
                Brand: itm.vendor,
                Categories: "",
                CompareAtPrice: theme.Currency.formatMoney(0, esn.getMoneyFormat()),
                ImageURL: itm.image,
                Name: itm.title,
                Price: theme.Currency.formatMoney(itm.final_price, esn.getMoneyFormat()),
                ProductID: itm.product_id,
                URL: window.location.origin + Shopify.routes.root + (itm.url.startsWith("/") ? itm.url.slice(1) : itm.url)
              };
              for (i=0; i < q; i++) {
                // Use an anonymous function that is called with setTimeout
                setTimeout(function() {
                  // Add the element with the push function
                  window._learnq.push(['track', 'Added to Cart', klavProduct]);
                }, 1000 * j); // Multiply the timeout by the index to create a gap of 1 second
                j++;
              }
            }

            // write product object (item) in an array for klaviyo
            else if (element && element.hasClass("add-to-cart") && meta.product.type !== "bundle") {
              for (i=0; i < q; i++) {
                // Use an anonymous function that is called with setTimeout
                setTimeout(function() {
                  // Add the element with the push function
                  window._learnq.push(['track', 'Added to Cart', item]);
                }, 1000 * i); // Multiply the timeout by the index to create a gap of 1 second
              }
            }

            // products object for gtm
            products.push({
              name: itm.title,
              id: itm.product_id,
              sku: itm.sku,
              price: itm.final_price / 100,
              brand: itm.vendor,
              category: itm.product_type,
              variant: itm.variant_title,
              quantity: q
            })
          }
        }

        window.dataLayer.push({
          event: "addToCart",
          ecommerce: {
            currencyCode: Shopify.currency && Shopify.currency.active ? Shopify.currency.active : "EUR",
            add: {
              products: products
            }
          }
        })
      }
    });

    //DEV-1305, Free product private app. Account.substitute

    const errorObj = JSON.parse($("#shop-settings").text()).substitute_errors;

    let $substituteCode = $("#substitute-code");
    let $substituteButton = $(".dgs-btn[lock-button='substitute-check']");
    let lastEntry = "";
    let lastCaret = 0;

    $substituteButton.on("click", checkSubstituteCode);

    $substituteCode.on('keydown', function (e) {
        lastEntry = $(this).val();
        if (e.which == '13') {
            e.preventDefault();
            checkSubstituteCode();
        }
    }).on('keyup', function (e) {
        let name = $(this).attr("name");
        let ctrl = document.querySelector("input[name='" + name + "']");

        lastCaret = getCaretPosition(ctrl);

        var n = $(this).val().toUpperCase();
        $(this).val(lastEntry.toLocaleString());
        var n = n.replaceAll(/[^0-9a-zA-Z\.]+/g, "");
        if (n.length > 4) {
            let c = n.match(/.{1,4}/g);
            var n = c.join("-");
        }

        $(this).val(n.toLocaleString());
        if (e.which == '8') {
            setCaretPosition(ctrl, lastCaret.start, lastCaret.start);
        }
    });

    function resetSubstituteErrors() {
        $substituteButton.prop("disabled", false);
        $substituteCode.prop("disabled", false)
            .removeClass("error").next("error").text("");
    }

    function checkSubstituteCode() {
        resetSubstituteErrors();
        let code_input = $substituteCode.val();
        if (code_input == "" || code_input.length < 19) {
            let errorMsg = (code_input == "") ? errorObj.undefined : errorObj.short_code;
            $substituteCode.addClass("error").next("error").text("" + errorMsg);
        } else {
            $substituteCode.prop("disabled", true);
            $substituteButton.prop("disabled", true);
            proxySubstituteCode(code_input);
        }
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
    }

    function displaySubstituteResult(result) {
        let stoSes = getCookie('_shopify_s');
        let stoWin = {'t_si': md5(stoSes), 't_wr': btoa(encodeURI(JSON.stringify(result)))};
        sessionStorage.setItem('__t_wd', JSON.stringify(stoWin));
        getSubstituteResult(result.type, result.value, result.win_id);
    }
    function getSubstituteResult(type, value, id) {
        $("#substitute-result").attr("fetchloading", "");
        let stoSes = getCookie('_shopify_s');
        fetch(window.location.pathname + '?section_id=promocode-product&view=' + type + '&show=' + value + '&winid=' + id, {cache: "no-cache"}).then(function (response) {
            return response.text();
        }).then(function (response) {
            let data = response;
            $('html,body').scrollTop(0);
            $('.account-promo__content-wrapper').after(response)
            $(document).trigger('promocode-product:loaded')
        });
    }

    async function proxySubstituteCode(code) {
        let shopSettings = esn.getShopSettings();
        let fetchURL = window.Shopify.routes.root + "apps/supportCenter/code/check?";
        let hash = sha256.hmac.create(shopSettings.support_center_secret).update("code=" + code).hex();

        fetchURL = fetchURL + "code=" + code + "&hash=" + hash;

        const substituteResponse = await fetch(fetchURL);

        switch (substituteResponse.status) {
            case 500: {
                resetSubstituteErrors();
                $substituteCode.addClass("error").next("error").text(`${errorObj.system_offline} (${substituteResponse.status})`);
            }
                break;
            case 429: {
                $substituteButton.prop("disabled", true).removeAttr('loadercover');
                $substituteCode.prop("disabled", true);
            }
                break;
            case 404: {
                resetSubstituteErrors();
                $substituteCode.addClass("error").next("error").text(`${errorObj.system_offline} (${substituteResponse.status})`);
            }
                break;
            case 400: {
                resetSubstituteErrors();
                const substituteBody = await substituteResponse.json();

                if (substituteBody.code == 2) {
                    $substituteCode.addClass("error").next("error")
                        .text(errorObj.used);
                } else {
                    $substituteCode.addClass("error").next("error").text(errorObj.not_found);
                }
            }
                break;
            case 200: {
                const substituteBody = await substituteResponse.json();
                displaySubstituteResult(substituteBody);
            }
                break;
            default: {
                resetSubstituteErrors();
                $substituteCode.addClass("error").next("error").text(`${errorObj.system_offline} (${substituteResponse.status})`);
            }
        }
    }

    function getCaretPosition(ctrl) {
        // IE < 9 Support
        if (document.selection) {
            ctrl.focus();
            let range = document.selection.createRange();
            let rangelen = range.text.length;
            range.moveStart('character', -ctrl.value.length);
            let start = range.text.length - rangelen;
            return {
                'start': start,
                'end': start + rangelen
            };
        } // IE >=9 and other browsers
        else if (ctrl.selectionStart || ctrl.selectionStart == '0') {
            return {
                'start': ctrl.selectionStart,
                'end': ctrl.selectionEnd
            };
        } else {
            return {
                'start': 0,
                'end': 0
            };
        }
    }

    function setCaretPosition(ctrl, start, end) {
        if (ctrl.setSelectionRange) {

            ctrl.focus();
            ctrl.setSelectionRange(start, end);
        }
    }
    function md5(r){var n,t,e,o,u,f,i,a,c,g,C,h=function(r,n){return r<<n|r>>>32-n},l=function(r,n){var t,e,o,u,f;return o=2147483648&r,u=2147483648&n,f=(1073741823&r)+(1073741823&n),(t=1073741824&r)&(e=1073741824&n)?2147483648^f^o^u:t|e?1073741824&f?3221225472^f^o^u:1073741824^f^o^u:f^o^u},d=function(r,n,t,e,o,u,f){return r=l(r,l(l(function(r,n,t){return r&n|~r&t}(n,t,e),o),f)),l(h(r,u),n)},s=function(r,n,t,e,o,u,f){return r=l(r,l(l(function(r,n,t){return r&t|n&~t}(n,t,e),o),f)),l(h(r,u),n)},v=function(r,n,t,e,o,u,f){return r=l(r,l(l(function(r,n,t){return r^n^t}(n,t,e),o),f)),l(h(r,u),n)},m=function(r,n,t,e,o,u,f){return r=l(r,l(l(function(r,n,t){return n^(r|~t)}(n,t,e),o),f)),l(h(r,u),n)},S=function(r){var n,t="",e="";for(n=0;n<=3;n++)t+=(e="0"+(r>>>8*n&255).toString(16)).substr(e.length-2,2);return t};for(a=1732584193,c=4023233417,g=2562383102,C=271733878,n=(t=function(r){for(var n,t=r.length,e=t+8,o=16*((e-e%64)/64+1),u=new Array(o-1),f=0,i=0;i<t;)f=i%4*8,u[n=(i-i%4)/4]=u[n]|r.charCodeAt(i)<<f,i++;return f=i%4*8,u[n=(i-i%4)/4]=u[n]|128<<f,u[o-2]=t<<3,u[o-1]=t>>>29,u}(r=function(r){var n,t,e,o="";n=t=0,e=(r=(r+"").replace(/\r\n/g,"\n").replace(/\r/g,"\n")).length;for(var u=0;u<e;u++){var f=r.charCodeAt(u),i=null;f<128?t++:i=f>127&&f<2048?String.fromCharCode(f>>6|192)+String.fromCharCode(63&f|128):String.fromCharCode(f>>12|224)+String.fromCharCode(f>>6&63|128)+String.fromCharCode(63&f|128),null!=i&&(t>n&&(o+=r.substring(n,t)),o+=i,n=t=u+1)}return t>n&&(o+=r.substring(n,r.length)),o}(r))).length,e=0;e<n;e+=16)o=a,u=c,f=g,i=C,a=d(a,c,g,C,t[e+0],7,3614090360),C=d(C,a,c,g,t[e+1],12,3905402710),g=d(g,C,a,c,t[e+2],17,606105819),c=d(c,g,C,a,t[e+3],22,3250441966),a=d(a,c,g,C,t[e+4],7,4118548399),C=d(C,a,c,g,t[e+5],12,1200080426),g=d(g,C,a,c,t[e+6],17,2821735955),c=d(c,g,C,a,t[e+7],22,4249261313),a=d(a,c,g,C,t[e+8],7,1770035416),C=d(C,a,c,g,t[e+9],12,2336552879),g=d(g,C,a,c,t[e+10],17,4294925233),c=d(c,g,C,a,t[e+11],22,2304563134),a=d(a,c,g,C,t[e+12],7,1804603682),C=d(C,a,c,g,t[e+13],12,4254626195),g=d(g,C,a,c,t[e+14],17,2792965006),a=s(a,c=d(c,g,C,a,t[e+15],22,1236535329),g,C,t[e+1],5,4129170786),C=s(C,a,c,g,t[e+6],9,3225465664),g=s(g,C,a,c,t[e+11],14,643717713),c=s(c,g,C,a,t[e+0],20,3921069994),a=s(a,c,g,C,t[e+5],5,3593408605),C=s(C,a,c,g,t[e+10],9,38016083),g=s(g,C,a,c,t[e+15],14,3634488961),c=s(c,g,C,a,t[e+4],20,3889429448),a=s(a,c,g,C,t[e+9],5,568446438),C=s(C,a,c,g,t[e+14],9,3275163606),g=s(g,C,a,c,t[e+3],14,4107603335),c=s(c,g,C,a,t[e+8],20,1163531501),a=s(a,c,g,C,t[e+13],5,2850285829),C=s(C,a,c,g,t[e+2],9,4243563512),g=s(g,C,a,c,t[e+7],14,1735328473),a=v(a,c=s(c,g,C,a,t[e+12],20,2368359562),g,C,t[e+5],4,4294588738),C=v(C,a,c,g,t[e+8],11,2272392833),g=v(g,C,a,c,t[e+11],16,1839030562),c=v(c,g,C,a,t[e+14],23,4259657740),a=v(a,c,g,C,t[e+1],4,2763975236),C=v(C,a,c,g,t[e+4],11,1272893353),g=v(g,C,a,c,t[e+7],16,4139469664),c=v(c,g,C,a,t[e+10],23,3200236656),a=v(a,c,g,C,t[e+13],4,681279174),C=v(C,a,c,g,t[e+0],11,3936430074),g=v(g,C,a,c,t[e+3],16,3572445317),c=v(c,g,C,a,t[e+6],23,76029189),a=v(a,c,g,C,t[e+9],4,3654602809),C=v(C,a,c,g,t[e+12],11,3873151461),g=v(g,C,a,c,t[e+15],16,530742520),a=m(a,c=v(c,g,C,a,t[e+2],23,3299628645),g,C,t[e+0],6,4096336452),C=m(C,a,c,g,t[e+7],10,1126891415),g=m(g,C,a,c,t[e+14],15,2878612391),c=m(c,g,C,a,t[e+5],21,4237533241),a=m(a,c,g,C,t[e+12],6,1700485571),C=m(C,a,c,g,t[e+3],10,2399980690),g=m(g,C,a,c,t[e+10],15,4293915773),c=m(c,g,C,a,t[e+1],21,2240044497),a=m(a,c,g,C,t[e+8],6,1873313359),C=m(C,a,c,g,t[e+15],10,4264355552),g=m(g,C,a,c,t[e+6],15,2734768916),c=m(c,g,C,a,t[e+13],21,1309151649),a=m(a,c,g,C,t[e+4],6,4149444226),C=m(C,a,c,g,t[e+11],10,3174756917),g=m(g,C,a,c,t[e+2],15,718787259),c=m(c,g,C,a,t[e+9],21,3951481745),a=l(a,o),c=l(c,u),g=l(g,f),C=l(C,i);return(S(a)+S(c)+S(g)+S(C)).toLowerCase()}

    //DEV-1305, Free product private app. promocode.product

    $(document).on('promocode-product:loaded', () => {
       $('.substitute-error').hide();

        function cancelPromocode() {
            $('#shopify-section-promocode-product').remove();
        }

        function resetSubstituteButtons() {
            $substituteButton.prop("disabled", false);
            $substituteCode.prop("disabled", false)
                .removeClass("error").next("error").text("");
            $substituteCode.val('')
        }

        async function addItemFromForm() {
            let data = {
                items: [{
                    id: $(".product-single__form [name='id']").val(),
                    quantity: 1,
                    properties: {
                        "_winid": $('#substitute-result').attr('data-win-id')
                    }
                }]
            };

            let formButton = $('.substitute-add');
            formButton.addClass('btn--loading');

            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: data,
                dataType: "json",
                complete: function() {
                    formButton.removeClass('btn--loading');
                    $("body").trigger("added.ajaxProduct");
                }
            });
        }

        async function getCartCheck() {
            let url = '/cart.js';
            let response = await fetch(url);
            let commits = await response.json();

            let codes = '';
            let activeCode = $('#substitute-result').attr('data-win-id');

            commits.items.forEach((item) => {
                if (item.properties._winid && !codes.includes(item.properties._winid)) {

                    codes === '' ? codes = `${item.properties._winid}` : codes = `${codes}, ${item.properties._winid}`;
                }
            })

            if (codes.includes(activeCode)) {
                $('.substitute-error').show();
            } else {
                addItemFromForm();
            }
        }

        $('.product-single__form').submit(function (e) {
            e.preventDefault()
            getCartCheck()
        })

        $('.substitute-cancel').on('click', (e) => {
            e.preventDefault()
            cancelPromocode()
            resetSubstituteButtons()
        })
    });

    // add download link to TOS/AGB
    if (window.location.pathname.indexOf('/terms-of-service') >= 0) {
        let tosSettings = $("#tos-download-settings"),
            button = $('#tos-download-btn');

        if (tosSettings.length && button.length) {
            tosSettings = JSON.parse(tosSettings.text());

            $('.shopify-policy__container')[0].appendChild(button[0]);
            button.removeClass('hidden');

            button.on("click", function(e) {
                e.preventDefault();
                button.width(button.width());
                button.addClass('btn--loading');

                fetch(this.getAttribute('href')).then(resp => resp.blob()).then(function(blob) {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');

                    a.style.display = 'none';
                    a.href = url;
                    a.download = tosSettings.filename + '.pdf';
                    document.body.appendChild(a);

                    a.click();
                    window.URL.revokeObjectURL(url);
                    button.removeClass('btn--loading');
                    button.width('');
                });
            });
        }
    }
});

// remove ZIP input box on parcellab tracking page
/*
let tntPaths = ['/shipment-tracking', '/track-and-trace'];
if (tntPaths.some(path => window.location.pathname.includes(path))) {
  removeZip = function() {
    let zipContainer = $('#parcellab-track-and-trace .pl-zip');
    zipContainer.remove();
  }

  let observer = new MutationObserver(removeZip);
  observer.observe(document.getElementById("parcellab-track-and-trace"), {attributes: false, childList: true, subtree: true});
}
*/

// show hidden products again if certain discount codes were used (if set up to do so)
showHiddenProducts = function() {
    if (hiddenProductsSettings = esn.getHiddenProductsSettings()) {
        if (typeof discountCode === "undefined") {
            discountCode = (discountCode = esn.getCookie("discount_code")) ? discountCode.toLowerCase() : null;
        }

        if (discountCode) {
            var hiddenProductsInDom = $('div.grid__item.grid-product.hidden_product.hidden, div.grid__item.grid-product.hidden_product.hiddeni');

            if (hiddenProductsInDom.length) {
                iSettings = (typeof iSettings !== "undefined") ? iSettings : esn.getISettings();

                // check if cookie with discount code also matches the discount code setup
                if (hiddenProductsSettings.allow_all_icodes == 'true' && $.inArray(discountCode, iSettings.icodes.join(',').toLowerCase().split(',')) >= 0
                    || (hiddenProductsSettings.allow_specific_codes && $.inArray(discountCode, hiddenProductsSettings.allow_specific_codes.toLowerCase().split('|')) >= 0)) {
                    $(hiddenProductsInDom).each(function(i, hiddenProduct) {
                        // show product
                        $(hiddenProduct).removeClass('hidden hiddeni');
                    });
                }
            }
        }
    }
};

$('body').on('recommendationsUpdated', function() {
    showHiddenProducts();
});

class LocalizationSwitcher extends HTMLElement {
    constructor() {
        super();

        this.open = false;
        this.elements = {
            wrapper: this.querySelector('.localization__current-wrapper'),
            formWrapper: this.querySelector('.localization__form'),
            form: this.querySelector('#localization_form'),
            formReturn: this.querySelector('#localization_form input[name=return_to]'),
            button: this.querySelector('button'),
            icon: this.querySelector('.localization__current-wrapper svg'),
        };
        this.domain = window.location.host.split('.');
        this.domain = this.domain[this.domain.length - 2] + '.' + this.domain[this.domain.length - 1];

        if (this.elements.wrapper) {
            this.elements.wrapper.addEventListener('click', this.toggleFormWrapper.bind(this));
        }
        if (this.elements.button) {
            this.elements.button.addEventListener('click', this.submitForm.bind(this));
        }

        if (this.elements.form) {
            this.elements.form.action = '/localization';
        }

        this.applyLocalization();
    }

    toggleFormWrapper(e) {
        this.elements.formWrapper.classList.toggle('open');
        this.elements.icon.classList.toggle('open');
        this.open = !this.open;

        if (this.open) {
            var self = this;

            e.preventDefault();
            e.stopPropagation();

            function autoClose(event) {
                if(!$(event.target).closest('.localization__form').length &&
                    $('.localization__form').is(":visible")) {
                    $(document).off('click', autoClose);
                    self.hideFormWrapper();
                }
            }

            $(document).on('click', autoClose);
        }
    }

    hideFormWrapper() {
        this.elements.formWrapper.classList.remove('open');
        this.elements.icon.classList.remove('open');
        this.open = false;
    }

    submitForm() {
        this.elements.button.classList.add('btn--loading');

        // redirect to homepage if switching markets
        var selectedCountry = $('#CountryList')[0].selectedOptions[0].value,
            market = esn.getShopSettings().market,
            markets = esn.getShopSettings().markets,
            countryDomain = esn.getShopSettings().host_by_country[selectedCountry.toLowerCase()],
            tntPaths = ['/shipment-tracking', '/track-and-trace'];

        if (markets[countryDomain] !== market && !(window.location.pathname.indexOf('/pages/') >= 0 || window.location.pathname.indexOf('/policies/') >= 0)) {
            this.elements.formReturn.value = '/';
        } else if (tntPaths.some(path => window.location.pathname.includes(path))) {
            this.elements.formReturn.value = '/';
        }

        // when switcher is used from a subdomain, save the form data in a separate cookie to apply it on next page load.
        // this is due to the settings not taking effect otherwise.
        if (market != 'domestic') {
            var selectedLanguage = $('#LanguageList')[0].selectedOptions[0].value;
            Cookies.set('localization_changeto', 'country_code=' + selectedCountry + ',language_code=' + selectedLanguage, {domain: this.domain});
        }

        // update user country line item property for discount code if switching domains
        if (countryDomain == window.location.host) {
          Cookies.set('add_discount_after_reload', 1);
        }
    }

    applyLocalization() {
        // check if localization settings need to be applied
        var localeNew = Cookies.get('localization_changeto');

        if (!localeNew) return;

        var locale = Cookies.get('localization'),
            countryNew = localeNew.match(/country_code=([^,]*)/);

        if (countryNew.length) {
            locale = locale.toUpperCase();
            countryNew = countryNew[1].toUpperCase();

            if (locale !== countryNew) {
                // set values in localization form and submit it
                var countrySelect = $('#CountryList');
                countrySelect.val(countryNew).change();

                var lang = localeNew.match(/language_code=([^,]*)/);
                if (lang.length) {
                    lang = lang[1].toLowerCase();

                    var langSelect = $('#LanguageList');
                    langSelect.val(lang).change();
                }

                $('#localization_form button[type=submit]').click();
            }
        }

        Cookies.remove('localization_changeto', {domain: this.domain});
    }
}
customElements.define('localization-switcher', LocalizationSwitcher);
